/* eslint-disable react-hooks/exhaustive-deps */
import React, { useMemo } from "react";
import { useState, useEffect, useRef } from "react";
import "./index.css";
import { toast } from "react-toastify";
import {
  addStatementDescription,
  downloadAllOwnerStatement,
  getAllOwnerAccStatement,
  ownerAccountsViewAll,
  resetStatementData,
  setOwnerAllAccStatementLoading,
  updateStatementData,
  setEndDate,
  setStartDate,
  resetDateRange,
} from "../../../../redux/features/owner/ownerAllVerification/ownerAllVerification";

import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  addMatchConsolidatedStatement,
  getAssociatedConsolidatedStatements,
  removeUnmatchConsolidatedStatement,
  resetConsolidatedAllAccStatementData,
  setGetConsolidatedAllAccStatementLoading,
} from "../../../../redux/features/accounts/remitterAccount/remitterAccount";

import PaginationComponent from "../../../../components/_utils/PaginationComponent";
import { formatAccountNumber } from "../../../../components/_utils/FormatAccountNumber";
import IfscCodeMapper from "../../../../components/_utils/IfscLogoMapper";
import OwnerAccountPopUp from "../../../../components/Accounts/OwnerAccount/OwnerAccountPopUp";
import FormatAmount from "../../../../components/_utils/FormatAmount/FormatAmount";
import OwnerDetailsPage from "../OwnerAccountDetails";
import PrimaryButton from "../../../../components/_utils/CommonButtons/PrimaryButton";
import PrimaryWithIconButton from "../../../../components/_utils/CommonButtons/PrimaryWithIconButton";
import SmallPopup from "../../../../components/_utils/CommonSmallPopup";
import SmallPopupWithInput from "../../../../components/_utils/CommonSmallPopupWithInput";
import {
  GlobalConfiguration,
  IntervalConfiguration,
  PaginationConfiguration,
} from "../../../../utils/configurationProvider";
import { linkIdentifier } from "../../../../utils/linkIdentifier";
import LargePopupRedirect from "../../../../components/_utils/CommonPopups/CommonLargePopupRedirect";
import UniversalRefreshToast from "../../../../components/_utils/UniversalRefreshToast";
import ICONS from "../../../../assets/Icons";
import CommonToast from "../../../../components/_utils/CommonToast";
import StatementTopNavComponent from "../../../../components/_utils/CommonTopNav/StatementTopNavComponent";
import useCustomSearchParams from "../../../../utils/useCustomSearchParams";
import RemitAccountViewAllPopup from "../../../../components/Accounts/RemitAccount/RemitAccountViewAllPopup";
import RemitterAccountViewAll from "../../RemitterAccount/RemitterAccountViewAll";
import SecondaryAnimatedButton from "../../../../components/_utils/CommonButtons/SecondaryAnimated";
import useRestrictedAction from "../../../../hooks/useRestrictedAction";

const OwnerAccountConsolidatedBankStatement = (props) => {
  const amtDivRef = useRef(null);
  const location = useLocation();
  const id = location?.state?.data;
  const type = location?.state?.type;
  const startDateDetails = location?.state?.startDate;
  const endDateDetails = location?.state?.endDate;
  const ownerIddetails = location?.state?.ownerId;
  const { showRestrictedAction, RestrictedActionPopup } = useRestrictedAction();
  const buttonRef = useRef();
  const dropdownOptionsList = PaginationConfiguration.paginationOptions;
  const { searchParam, handleSearchParams } = useCustomSearchParams({
    pageno: GlobalConfiguration.lengthCheckOne,
    pagesize: dropdownOptionsList[0],
  });

  const {
    ownerAllAccStatementData,
    ownerAllAccStatementLoading,
    ownerAllAccAddDescriptionLoading,
  } = useSelector((state) => state.ownerAllVerification);

  const { getAssociatedConsolidatedData, getAssociatedConsolidatedLoading } =
    useSelector((state) => state.remitterAccount);

  const services = useSelector((state) => state.refreshToken.services);
  const hasMatchPermission = services?.some(
    (service) => service === "AMapping" || service === "Admin",
  );
  const hasUnMatchPermission = services?.some(
    (service) => service === "RMapping" || service === "Admin",
  );

  const hasViewPermission = services?.some(
    (service) => service === "REVAccount" || service === "Admin",
  );

  const navigate = useNavigate();
  const scrollTopRef = useRef(null);

  const convertDate = (dateString) => {
    const date = new Date(dateString);
    const timestamp = Math.floor(
      date.getTime() / IntervalConfiguration.intervalMedium,
    );

    return timestamp;
  };
  const [flowType, setFlowType] = useState(location?.state?.flow || "");
  const [matchFlowType, setMatchFlowType] = useState(
    location?.state?.flow || "",
  );
  const [matchId, setMatchId] = useState(location?.state?.data || "");
  const dropdownOptions = PaginationConfiguration.paginationOptions;
  const [searchUserTextDebounce, setSearchUserTextDebounce] = useState("");
  const [inputData, setInputData] = useState([]);
  const [remType, setRemType] = useState("");
  const [alertPopup, setAlertPopup] = useState(false);
  const [pendingNavTarget, setPendingNavTarget] = useState(null);
  const [remitterName, setRemitterName] = useState(
    location?.state?.remName || "",
  );
  const [matchLoader, setMatchLoader] = useState(false);
  const [remiAcoountId, setRemiAcoountId] = useState(id || []);

  const [unmatchLoader, setUnmatchLoader] = useState(false);
  const [selectedBankStatement, setSelectedBankStatement] = useState(
    location?.state?.statementid || [],
  );

  const [selectStatementType, setSelectStatementType] = useState(
    location?.state?.flow || "",
  );

  const [selectStatementRow, setSelectStatementRow] = useState([]);
  const [totalRemiAccount, setTotalRemiAccount] = useState([]);
  const [unmatchRemiId, setUnmatchRemiId] = useState([]);
  const [matchRemiId, setMatchRemiId] = useState([]);

  const [showInnerSearchBar, setShowInnerSearchBar] = useState(false);
  const [openMatchPopup, setOpenMatchPopup] = useState(false);
  const [showRemiAccounts, setShowRemiAccounts] = useState(false);
  const [showSearchBar, setShowSearchBar] = useState(false);
  const [openDateFilter, setopenDateFilter] = useState(false);
  const [selectedStatementRemitters, setSelectedStatementRemitters] = useState(
    {},
  );
  const [matchButton, setMatchButton] = useState(
    (selectStatementType === "remitter_details_match_statement" ||
      selectStatementType === "remitter_edit_match_statement" ||
      flowType === "new_match_txn") &&
      ownerAllAccStatementData?.statement?.length >
        GlobalConfiguration.lengthCheckZero
      ? true
      : false,
  );
  const [selectedCardIds, setSelectedCardIds] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingData, setLoadingData] = useState(false);
  const [unmatchStatement, setUnMatchStatement] = useState("");
  const [matchStatement, setMatchStatement] = useState("");
  const [active, setActive] = useState("");
  const [selectStatement, setSelectStatement] = useState(false);
  const [showOwnerPopup, setShowOwnerPopup] = useState(false);
  const [showOwnerDetailPopup, setShowOwnerDetailPopup] = useState(false);
  const [ownerDetailId, setOwnerDetailID] = useState("");
  const [showAmtFilterDiv, setShowAmtFilterDiv] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [isAmtFilterApplied, setIsAmtFilterApplied] = useState(false);
  const [isDateConfirm, setIsDateConfirm] = useState(false);
  const scrollRef = useRef(null);
  const [filterOpen, setFilterOpen] = useState(false);
  const [showAdditionalDetails, setShowAdditionalDetails] = useState(false);
  const [showCalendar, setShowCalendar] = useState(false);
  const calenderRef = useRef(null);
  const calenderButtonRef = useRef(null);
  const additionalDetailsRef = useRef(null);
  const additionalDetailsBtnRef = useRef(null);
  const filterButtonRef = useRef(null);
  const selectAccountRef = useRef(null);
  const [pageSize, setPageSize] = useState(dropdownOptions[0]);
  const [selectedValue, setSelectedValue] = useState(dropdownOptions[0]);
  const dispatch = useDispatch();
  const filterRef = useRef(null);
  const filterapplyButtonRef = useRef(null);
  const addtionalapplyButtonRef = useRef(null);
  const calenderapplyButtonRef = useRef(null);
  const [debiteAmount, setDebitAmount] = useState("");
  const [creditAmount, setCreditAmount] = useState("");
  const [selectedtBankState, setSelectedtBankState] = useState("");
  const [amountRangeFilter, setAmountRangeFilter] = useState({
    min:
      props?.flow === "rejectStatementdetails"
        ? ""
        : searchParam.get("min_amount") || "",
    max:
      props?.flow === "rejectStatementdetails"
        ? ""
        : searchParam.get("max_amount") || "",
  });
  const [selectedtBank, setSelectedtBank] = useState("");
  const [showConfirmPopup, setShowConfirmPopup] = useState(false);
  const [showDescriptionPopup, setShowDescriptionPopup] = useState(false);
  const [description, setDescription] = useState("");

  const [currentDescription, setCurrentDescription] = useState({});
  const [isFocused, setIsFocused] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [source, setSource] = useState("");
  const [sourceState, setSourceState] = useState("");
  const [statementType, setStatementType] = useState("");
  const [statementTypeState, setStatementTypeState] = useState("");

  const [amountLimitState, setAmountLimitState] = useState({
    min: "",
    max: "",
  });
  const [amountLimit, setAmountLimit] = useState({
    min: "",
    max: "",
  });
  const [accountnumberstate, setaccountnumberstate] = useState(
    ownerIddetails
      ? [ownerIddetails]
      : props?.flow === "rejectStatementdetails"
        ? []
        : props?.popType == "ownerStatement" ||
            props?.popType === "remitterBankStatement"
          ? [props?.ownerDetailId]
          : [],
  );

  const [accountNumber, setAccountNumber] = useState(
    ownerIddetails
      ? location?.state?.type === "consolidatedFullView" ? [ownerIddetails] :ownerIddetails 
      : props?.popType == "ownerStatement" ||
          props?.popType === "remitterBankStatement"
        ? [props?.ownerDetailId]
        : [],
  );
  const [accountDefaultNumber, setDefaultAccountNumber] = useState(
    ownerIddetails
      ? [ownerIddetails]
      : props?.popType == "ownerStatement" ||
          props?.popType === "remitterBankStatement"
        ? [props?.ownerDetailId]
        : [],
  );
  const [selectedType, setSelectedType] = useState("XLSX");
  const fileTypeRef = useRef(null);
  const fileTypeRef2 = useRef(null);
  const matchCondition =
    matchFlowType === "new_match_txn" ||
    matchFlowType === "remitter_details_match_statement" ||
    matchFlowType === "remitter_edit_match_statement";

  const defaultStartDate = useMemo(() => {
    return convertDate(new Date(new Date().setDate(1)));
  }, []);

  const defaultEndDate = useMemo(() => {
    return convertDate(new Date());
  }, []);

  const [startDateState, setStartDateState] = useState(
    startDateDetails ||
      (props?.flow === "rejectStatementdetails" ? "" : defaultStartDate),
  );

  const [endDateState, setEndDateState] = useState(
    endDateDetails ||
      (props?.flow === "rejectStatementdetails" ? "" : defaultEndDate),
  );

  // const [startDate, setStartDate] = useState(new Date(new Date().setDate(1)));

  // const [endDate, setEndDate] = useState(new Date());

  const formatAmount = (value) => {
    if (!value) return "";

    return `INR ${Number(value.replace(/,/g, "")).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  };

  const statements =
    type === "remitter_details" || props?.flow === "rejectStatementdetails"
      ? getAssociatedConsolidatedData?.statement
      : ownerAllAccStatementData?.statement;

  const visibleRowIds =
    statements?.map(
      (item, index) =>
        item?.account_statement_entry_id ||
        item?.id ||
        `${currentPage}-${index}`,
    ) || [];

  const currentPageSelectableIds = visibleRowIds.filter(
    (id) => !selectedBankStatement?.includes(id),
  );

  const currentPageSelectedIds = currentPageSelectableIds.filter((id) =>
    selectStatementRow.includes(id),
  );

  const currentPageSelectedCount = currentPageSelectedIds.length;

  const totalUserSelectedCount = selectStatementRow.filter(
    (id) => !selectedBankStatement?.includes(id),
  ).length;

  const remainingSelection = Math.max(
    Number(pageSize) - totalUserSelectedCount,
    0,
  );

  const hasSelectionOutsideCurrentPage =
    currentPageSelectedCount === GlobalConfiguration.lengthCheckZero &&
    selectStatementRow.some(
      (id) =>
        !selectedBankStatement?.includes(id) &&
        !currentPageSelectableIds.includes(id),
    );

  const shouldClearPreviousSelection =
    hasSelectionOutsideCurrentPage &&
    remainingSelection === GlobalConfiguration.lengthCheckZero;

  const totalSelectedCount = totalUserSelectedCount;

  const totalRecordCount = Number(
    (type === "remitter_details" || props?.flow === "rejectStatementdetails"
      ? getAssociatedConsolidatedData?.total_count
      : ownerAllAccStatementData?.total_count) || 0,
  );

  const effectiveSelectCap = Math.min(totalRecordCount, Number(pageSize));

  const isAllVisibleSelected =
    totalSelectedCount === effectiveSelectCap && effectiveSelectCap > 0;
  const defaultAdditionalDetailCol = [
    { colName: "Bank", colWidth: "column-width-sm", flex: 0 },
    {
      colName: "Transaction date and time",
      colWidth: "column-width-md",
      flex: 0,
    },
    { colName: "Value date", colWidth: "column-width-md", flex: 0 },
    {
      colName: "Bank reference number",
      colWidth: "column-width-lg",
      flex: 0,
    },
    { colName: "Narration", colWidth: "column-width-lg", flex: 1 },
    { colName: "Type", colWidth: "column-width-md", flex: 0 },
    { colName: "Amount", colWidth: "column-width-md", flex: 0 },
    { colName: "Debit amount", colWidth: "column-width-md", flex: 0 },
    { colName: "Credit amount", colWidth: "column-width-md", flex: 0 },
    { colName: "Closing balance", colWidth: "column-width-md", flex: 0 },
    { colName: "Account number", colWidth: "column-width-md", flex: 0 },
    { colName: "Name", colWidth: "column-width-md", flex: 0 },
    { colName: "IFSC code", colWidth: "column-width-md", flex: 0 },
    { colName: "Statement source", colWidth: "column-width-md", flex: 0 },
    { colName: "Description", colWidth: "column-width-lg", flex: 1 },

    ...(props?.flow !== "rejectStatementdetails"
      ? [
          {
            colName: "Remitter account",
            colWidth: "column-width-lg",
            flex: 1,
          },
        ]
      : []),
  ];

  const [additionalDetailColState, setAdditionalDetailsColState] = useState(
    defaultAdditionalDetailCol,
  );

  const [isEditDescription, setIsEditDescription] = useState(false);
  useEffect(() => {
    const fetchData = async () => {
      try {
        let response = await dispatch(ownerAccountsViewAll({}));
      } catch (error) {}
    };

    fetchData();

    return () => {
      dispatch(resetStatementData());
    };
  }, []);

  const handleSubmit = (key, value) => {
    handleSearchParams(key, value);
  };

  const columnMapper = {
    "Transaction date and time": "Date and Time",
    "Value date": "Value Date",
    "Bank reference number": "Bank Reference No.",
    Narration: "Narration",
    Type: "Type",
    Amount: "Amount",
    "Debit amount": "Debit Amount",
    "Credit amount": "Credit Amount",
    Bank: "Bank Name",
    "Account number": "Account Number",
    "IFSC code": "IFSC Code",
    "Closing balance": "Closing Balance",
    "Statement source": "Statement Source",
    Description: "Description",
  };

  const handleFetch = async () => {
    setLoading(true);

    try {
      if (
        type === "remitter_details" ||
        props?.flow === "rejectStatementdetails"
      ) {
        await dispatch(
          getAssociatedConsolidatedStatements({
            page_no: currentPage,
            page_size: pageSize,
            remitter_account_id: props?.remitter_account_id || "",
            statement_entry_id: props?.statement_entry_id
              ? [props?.statement_entry_id]
              : [],
            min_amount: isAmtFilterApplied ? amountRangeFilter.min : "",
            max_amount: isAmtFilterApplied ? amountRangeFilter.max : "",
            start_date: startDateState,
            end_date: endDateState,
            credit_amount: creditAmount || "",
          }),
        ).unwrap();
      } else {
        await dispatch(
          getAllOwnerAccStatement({
            id: accountNumber?.map((itm) => (itm?.id ? itm.id : itm)),
            start_date: formatDate(startDateState),
            end_date: formatDate(endDateState),
            page_no: currentPage,
            sort_by:
              matchStatement === "Matched"
                ? "mapped"
                : unmatchStatement === "Unmatched"
                  ? "unmapped"
                  : "",
            credit_debit: statementTypeState,
            start_amount: isAmtFilterApplied ? amountRangeFilter.min : "",
            end_amount: isAmtFilterApplied ? amountRangeFilter.max : "",
            credit_amount: creditAmount || "",
            debit_amount: debiteAmount || "",
            page_size: pageSize,
            entry_source: sourceState.length
              ? sourceState === "Uploaded manually"
              : undefined,
            bank_name: selectedtBank.length ? selectedtBank : undefined,
          }),
        ).unwrap();
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (accountNumber.length) {
      handleFetch();
    } else {
      if (
        type === "remitter_details" ||
        props?.flow === "rejectStatementdetails"
      ) {
        dispatch(setGetConsolidatedAllAccStatementLoading(false));
      } else {
        dispatch(setOwnerAllAccStatementLoading(false));
      }
    }

    return () => {
      if (
        type === "remitter_details" ||
        props?.flow === "rejectStatementdetails"
      ) {
        dispatch(resetConsolidatedAllAccStatementData());
      }
    };
  }, [
    currentPage,
    statementTypeState,
    pageSize,
    accountNumber,
    selectedtBank,
    startDateState,
    endDateState,
    source,
    amountRangeFilter,
    sourceState,
    matchStatement,
    creditAmount,
    unmatchStatement,
    debiteAmount,
  ]);

  useEffect(() => {
    // if (flow !== "remitter_edit_match_statement") {
    //   return;
    // } else {

    const fetchData = async () => {
      if (
        type === "remitter_details" ||
        props?.flow === "rejectStatementdetails"
      ) {
        const itemisedResponse = await dispatch(
          getAssociatedConsolidatedStatements({
            remitter_account_id: remiAcoountId,
            page_no: currentPage,
            page_size: pageSize,
          }),
        );

        if (
          getAssociatedConsolidatedStatements.fulfilled.match(itemisedResponse)
        ) {
          const statementIds =
            itemisedResponse?.payload?.statement
              ?.map((data) => data?.account_statement_entry_id)
              ?.filter(Boolean) || [];

          setSelectedBankStatement(statementIds);
        }
      }

      // };
    };

    if (matchCondition) {
      fetchData();
    }
  }, [remiAcoountId, currentPage, pageSize]);

  const handleApplyEnable = () => {
    if (
      accountDefaultNumber.length &&
      accountnumberstate.length &&
      !accountNumber.length
    ) {
      return true;
    }
    if (
      accountDefaultNumber.length === accountnumberstate.length &&
      accountDefaultNumber.every((ac) => {
        return accountnumberstate.includes(ac);
      }) &&
      accountDefaultNumber.length === accountNumber.length &&
      accountDefaultNumber.every((ac) => {
        return accountNumber.includes(ac);
      }) &&
      !selectedtBank.length &&
      !amountLimit.min.length &&
      !amountLimit.max.length &&
      !statementType.length &&
      !selectedtBankState.length &&
      !isAmtFilterApplied &&
      !sourceState &&
      !statementTypeState.length
    ) {
      return false;
    }
    return true;
  };

  const handleSearch = (text) => {
    setSearchUserTextDebounce(text);
  };


  
    const actionRestricted = () => {
      showRestrictedAction({
        path: `/owner_account_dashboard/consolidated_bank_statement/`,
           state: {
                        startDate: startDateState,
                        endDate: endDateState,
                        ownerId: accountNumber,
                      },
      });
    };

  

  const handleAddDetailaApplyEnable = () => {
    return (
      JSON.stringify(defaultAdditionalDetailCol) !=
        JSON.stringify(additionalDetailColState) ||
      JSON.stringify(defaultAdditionalDetailCol) !=
        JSON.stringify(additionalDetailColState)
    );
  };

  const downloadStatement = async () => {
    UniversalRefreshToast("Downloading statement.");
    setIsDisabled(true);
    try {
      const response = await dispatch(
        downloadAllOwnerStatement({
          id: accountNumber,
          start_date: formatDate(startDateState),
          end_date: formatDate(endDateState),
          credit_debit: statementTypeState,
          start_amount: isAmtFilterApplied ? amountRangeFilter.min : "",
          end_amount: isAmtFilterApplied ? amountRangeFilter.max : "",
          page_size: pageSize,
          formatType: selectedType.toLowerCase(),
          bank_name: selectedtBank.length ? selectedtBank : undefined,
          entry_source: sourceState.length
            ? sourceState === "Uploaded manually"
              ? true
              : false
            : undefined,
          filter_columns: additionalDetailColState.map(
            (itm) => columnMapper[itm.colName],
          ),
        }),
      );
      toast.dismiss();
      CommonToast({
        text: "Statement downloaded successfully.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      setIsDisabled(false);
      if (!response?.payload?.ok) {
        CommonToast({
          text: response?.payload?.message,
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      }
    } catch (error) {
      toast.dismiss();
      CommonToast({
        text: "Failed to download statement.",
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      setIsDisabled(false);
      console.error(error);
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Tab") {
      event.preventDefault();
    }
    if (filterOpen) {
      if (event.key === "Enter" && !showAmtFilterDiv && handleApplyEnable()) {
        filterapplyButtonRef.current.click();
      }
    }
    if (showCalendar) {
      if (
        event.key === "Enter" ||
        (isDateConfirm && startDateState && endDateState)
      ) {
        calenderapplyButtonRef.current.click();
      }
    }
    if (showAdditionalDetails) {
      if (event.key === "Enter" && handleAddDetailaApplyEnable()) {
        addtionalapplyButtonRef.current.click();
      }
    }
  };

  

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [
    filterOpen,
    showCalendar,
    showAdditionalDetails,
    showAmtFilterDiv,
    handleAddDetailaApplyEnable,
    handleApplyEnable,
  ]);

  const move = () => {
    scrollRef?.current?.scrollTo({ left: 0, behavior: "smooth" });
    setTimeout(() => {
      scrollTopRef?.current?.scrollTo({ top: 0, behavior: "smooth" });
    }, IntervalConfiguration.intervalExtraSmall);
  };

  // const handleSelect = (value) => {
  //   setCurrentPage(1);
  //   setSelectedValue(value);
  //   setPageSize(value);
  // };

  const handleSelect = (value) => {
    setCurrentPage(GlobalConfiguration.lengthCheckOne);
    setSelectedValue(value);
    setPageSize(value);

    if (Number(value) < Number(pageSize)) {
      const statements =
        type === "remitter_details" || props?.flow === "rejectStatementdetails"
          ? getAssociatedConsolidatedData?.statement
          : ownerAllAccStatementData?.statement;

      const visibleIds =
        statements
          ?.slice(0, Number(value))
          ?.map(
            (item, index) =>
              item?.account_statement_entry_id || item?.id || `1-${index}`,
          ) || [];

      setSelectStatementRow((prev) =>
        prev.filter(
          (id) =>
            selectedBankStatement?.includes(id) || visibleIds.includes(id),
        ),
      );

      setSelectedStatementRemitters((prev) => {
        const updated = {};

        Object.keys(prev || {}).forEach((key) => {
          if (
            selectedBankStatement?.includes(key) ||
            visibleIds.includes(key)
          ) {
            updated[key] = prev[key];
          }
        });

        const additionalIds = Array.isArray(remiAcoountId)
          ? remiAcoountId
          : remiAcoountId
            ? [remiAcoountId]
            : [];

        const uniqueIds = [
          ...new Set([...Object.values(updated).flat(), ...additionalIds]),
        ];

        setMatchRemiId(uniqueIds);

        return updated;
      });
    }
  };

  const handlePagination = (page) => {
    if (scrollRef?.current) {
      scrollRef.current.scrollLeft = GlobalConfiguration.lengthCheckZero;
    }
    setCurrentPage(page);
  };

  const computeVariant = (value, focused) => {
    const length = (value ?? "").trim().length;

    if (length === 0) return "default";

    if (length >= 0) {
      return "verified";
    }

    return focused ? "typing" : "error";
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        (additionalDetailsRef.current &&
          additionalDetailsRef.current.contains(e.target)) ||
        (additionalDetailsBtnRef.current &&
          additionalDetailsBtnRef.current.contains(e.target))
      ) {
      } else {
        setShowAdditionalDetails(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [additionalDetailsRef]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        (filterRef.current && filterRef.current.contains(e.target)) ||
        (filterButtonRef.current &&
          filterButtonRef.current.contains(e.target)) ||
        (selectAccountRef.current &&
          selectAccountRef.current.contains(e.target))
      ) {
      } else {
        setFilterOpen(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [filterRef]);

  useEffect(() => {
    const statements =
      type === "remitter_details" || props?.flow === "rejectStatementdetails"
        ? getAssociatedConsolidatedData?.statement
        : ownerAllAccStatementData?.statement;

    const currentVisibleIds =
      statements?.map(
        (item, index) =>
          item?.account_statement_entry_id ||
          item?.id ||
          `${currentPage}-${index}`,
      ) || [];

    setSelectStatementRow((prev) =>
      prev.filter(
        (id) =>
          selectedBankStatement?.includes(id) || currentVisibleIds.includes(id),
      ),
    );
  }, [pageSize]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        (calenderRef.current && calenderRef.current.contains(e.target)) ||
        (calenderButtonRef.current &&
          calenderButtonRef.current.contains(e.target))
      ) {
      } else {
        setShowCalendar(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [calenderRef]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (fileTypeRef.current && fileTypeRef.current.contains(e.target)) {
      } else if (
        fileTypeRef2.current &&
        fileTypeRef2.current.contains(e.target)
      ) {
      } else {
        setSelectStatement(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [fileTypeRef, fileTypeRef2]);

  useEffect(() => {
    if (
      (selectStatementType === "remitter_details_match_statement" ||
        selectStatementType === "remitter_edit_match_statement" ||
        flowType === "new_match_txn") &&
      ownerAllAccStatementData?.statement?.length >
        GlobalConfiguration.lengthCheckZero
    ) {
      setMatchButton(true);
      setStatementTypeState("Credit");
    }
  }, [
    selectStatementType,
    flowType,
    ownerAllAccStatementData?.statement?.length,
  ]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (amtDivRef.current && amtDivRef.current.contains(e.target)) {
      } else {
        setShowAmtFilterDiv(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [amtDivRef]);

  const handleMatchStatement = async (matchid) => {
    setMatchLoader(true);
    UniversalRefreshToast(
      flowType === "new_match_txn" ||
        flowType === "remitter_details_match_statement" ||
        selectStatementType === "remitter_edit_match_statement"
        ? "Matching transactions to the selected accounts."
        : "Matching remitter.",
    );

    try {
      const data = await dispatch(
        addMatchConsolidatedStatement({
          remitter_accounts_ids: Array.isArray(matchid) ? matchid : [matchid],
          mapping_ids: Array.isArray(selectStatementRow)
            ? selectStatementRow
            : [selectStatementRow],
        }),
      );

      if (data?.payload?.status === true) {
        toast.dismiss();
        CommonToast({
          text:
            flowType === "new_match_txn" ||
            flowType === "remitter_details_match_statement" ||
            selectStatementType === "remitter_edit_match_statement"
              ? `${
                  selectStatementRow?.length ===
                  GlobalConfiguration.lengthCheckOne
                    ? "Transaction"
                    : "Transactions"
                } matched to the selected ${matchCondition ? "account" : "accounts"} successfully.`
              : "Remitter matched successfully.",
          icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
          buttonNeeded: false,
        });
        if (remiAcoountId?.length > GlobalConfiguration.lengthCheckZero) {
          navigate(
            `/remitter_account_dashboard/remitter_account_view_all/remitter_account_detail_page/${remiAcoountId}`,
            {
              state: {
                flow: "match_transaction",
              },
            },
          );
        } else {
          setOpenMatchPopup(false);
          setShowRemiAccounts(false);
          handleFetch();
          setSelectedCardIds([]);
          setMatchButton(false);
          setSelectStatementRow([]);
          setRemType("");
        }
      } else {
        CommonToast({
          text:
            data?.payload?.message ||
            data?.payload?.errors?.base?.[0] ||
            "Failed to unmatch transactions.",
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
        setMatchLoader(false);
      }
    } catch (error) {
      CommonToast({
        text: "Something went wrong.",
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
    }
    setOpenMatchPopup(false);
    setMatchLoader(false);
  };

  const handleUnMatchStatement = async (matchid) => {
    setUnmatchLoader(true);
    UniversalRefreshToast("Unmatching remitter.");

    try {
      let data = await dispatch(
        removeUnmatchConsolidatedStatement({
          remitter_accounts_ids: matchid,
          mapping_ids: Array.isArray(selectStatementRow)
            ? selectStatementRow
            : [selectStatementRow],
        }),
      );

      if (data?.payload?.status === true) {
        toast.dismiss();
        CommonToast({
          text: "Remitter unmatched successfully.",
          icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
          buttonNeeded: false,
        });

        setShowRemiAccounts(false);
        setSelectStatementRow([]);
        setUnmatchRemiId([]);
        handleFetch();
        setSelectedCardIds([]);
        setRemType("");
      } else {
        CommonToast({
          text:
            data?.payload?.message ||
            data?.payload?.errors?.base?.[0] ||
            "Failed to unmatch transactions.",
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
        setSelectStatementRow([]);
        setUnmatchRemiId([]);
        setUnmatchLoader(false);
      }
    } catch (error) {
      CommonToast({
        text: "Something went wrong.",
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
    }
    setOpenMatchPopup(false);
    setUnmatchLoader(false);
  };

  const handleAddDetail = (name) => {
    if (!additionalDetailColState.some((x) => x.colName === name)) {
      let data = {
        colName: name,
        colWidth: defaultAdditionalDetailCol.find((x) => x.colName === name)
          ?.colWidth,
        flex: defaultAdditionalDetailCol.find((x) => x.colName === name)?.flex,
      };
      let arr = [...additionalDetailColState, data].sort(
        (a, b) =>
          defaultAdditionalDetailCol.map((x) => x.colName).indexOf(a.colName) -
          defaultAdditionalDetailCol.map((x) => x.colName).indexOf(b.colName),
      );
      setAdditionalDetailsColState(arr);
    } else {
      if (additionalDetailColState.length === 1) {
        return CommonToast({
          text: "Atleast one column is required",
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      }

      setAdditionalDetailsColState(
        additionalDetailColState
          .filter((itm) => {
            return name !== itm.colName;
          })
          .sort(
            (a, b) =>
              defaultAdditionalDetailCol
                .map((x) => x.colName)
                .indexOf(a.colName) -
              defaultAdditionalDetailCol
                .map((x) => x.colName)
                .indexOf(b.colName),
          ),
      );
    }
  };

  const formatDateandTime = (date, showtime) => {
    let hours = date.getUTCHours();
    const minutes = date.getUTCMinutes();
    const seconds = date?.getUTCSeconds() || 0;

    const ampm = hours >= 12 ? "pm" : "am";
    hours %= 12;
    hours = hours || 12;
    let todayDate = date.getUTCDate();
    let month = date.getUTCMonth() + 1;

    if (showtime) {
      return `${todayDate < 10 ? "0" + todayDate : todayDate}-${month < 10 ? "0" + month : month}-${date.getUTCFullYear()}, ${
        hours < GlobalConfiguration.panLength ? "0" + hours : hours
      }:${minutes < GlobalConfiguration.panLength ? "0" + minutes : minutes}:${seconds < 10 ? "0" + seconds : seconds} ${ampm}`;
    } else {
      return `${todayDate < 10 ? "0" + todayDate : todayDate}-${month < 10 ? "0" + month : month}-${date.getUTCFullYear()}`;
    }
  };

  const formatDate = (date) => {
    if (!date) return "";
    const d = new Date(Number(date) * IntervalConfiguration.intervalMedium);
    if (isNaN(d.getTime())) return "";
    const day = d.getDate();
    const month = d.toLocaleString("en-GB", { month: "short" });
    const year = d.getFullYear();

    return `${day} ${month} ${year}`;
  };

  const handleAmtFilterApply = () => {
    if (
      amountLimitState.min === "" ||
      amountLimitState.max === "" ||
      Number(amountLimitState.min) >= Number(amountLimitState.max)
    )
      return;
    setIsAmtFilterApplied(true);
    setTimeout(() => {
      setShowAmtFilterDiv(false);
    }, 500);
  };

  const handleDateChange = (date) => {
    const [start, end] = date;
    if (start !== null && end !== null) {
      const startTs = convertDate(start);
      const endTs = convertDate(end);
      setStartDateState(startTs);
      setEndDateState(endTs);

      if (props?.popType === "remitterBankStatement") {
        // Setting Dates in redux... will help in setting dates when redirecting from popup to full view.
        dispatch(setStartDate(startTs));
        dispatch(setEndDate(endTs));
      }

      handleSearchParams("date", `${startTs},${endTs}`);
    } else {
      setStartDateState(defaultStartDate);
      setEndDateState(defaultEndDate);

      handleSearchParams("date", "");
    }
  };

  useEffect(() => {
    return () => {
      if (props?.flow !== "remitterBankStatement") {
        dispatch(resetDateRange());
      }
    };
  }, []);

  const handleKey = (event) => {
    if (showAmtFilterDiv) {
      if (event.key === "Enter" && showAmtFilterDiv && isAmtFilterApplied) {
        handleAmtFilterApply();
      }
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", handleKey);
    return () => {
      document.removeEventListener("keydown", handleKey);
    };
  }, [isAmtFilterApplied, showAmtFilterDiv]);

  useEffect(() => {
    if (!pageSize) return;

    const visibleRowIds =
      type !== "remitter_details"
        ? ownerAllAccStatementData?.statement?.map(
            (item, index) =>
              item?.account_statement_entry_id ||
              item?.id ||
              `${currentPage}-${index}`,
          ) || []
        : getAssociatedConsolidatedData?.statement?.map(
            (item, index) =>
              item?.account_statement_entry_id ||
              item?.id ||
              `${currentPage}-${index}`,
          ) || [];

    setSelectStatementRow((prev) =>
      prev.filter(
        (id) =>
          selectedBankStatement?.includes(id) || visibleRowIds.includes(id),
      ),
    );
  }, [pageSize]);

  const condition =
    (startDateState !== defaultStartDate && endDateState !== defaultEndDate) ||
    selectedtBankState.length > GlobalConfiguration.lengthCheckZero ||
    (matchStatement !== "" && unmatchStatement !== "") ||
    matchStatement !== "" ||
    unmatchStatement !== "" ||
    debiteAmount !== "" ||
    creditAmount !== "" ||
    (amountRangeFilter.min.length > GlobalConfiguration.lengthCheckZero &&
      amountRangeFilter.max.length > GlobalConfiguration.lengthCheckZero);

  const handleLeaveConfirm = () => {
    setAlertPopup(false);
    setShowRemiAccounts(false);
    if (pendingNavTarget) {
      navigate(pendingNavTarget);
    }
    setPendingNavTarget(null);
  };

  const handleAlertCancel = () => {
    setAlertPopup(false);
    setPendingNavTarget(null);
  };

  const handleCardNavigate = (targetPath) => {
    setPendingNavTarget(targetPath);
    setAlertPopup(true);
  };

  return (
    <>{<>{RestrictedActionPopup}</>}
      {alertPopup && (
        <div
          className="fixed z-z-index-max flex items-center justify-center top-left-base left-left-base w-width-full h-height-full bg-PopUp-BackDrop bg-opacity-dark-opacity"
          onClick={(e) => e.stopPropagation()}
        >
          <SmallPopup
            headerTitle="Confirm leaving this page?"
            headerFontWeight="semibold"
            headerFontColor="emphasis"
            textSize="font-lg"
            subtext="Leaving this page will exit from the current flow."
            btnOneText="Stay"
            btnOneHandleFunction={handleAlertCancel}
            btnOneEnabledBgColor="var(--primary-bg)"
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneIsDisabled={false}
            btnOneHoverOption="white"
            btnTwoText="Leave"
            btnTwoHandleFunction={handleLeaveConfirm}
            btnTwoEnabledBgColor="var(--negative-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={false}
            btnTwoDisabledBgColor="var(--text-disabled)"
            btnTwoIsLoaderNeeded={true}
            btnTwoHoverOption="black"
          />
        </div>
      )}

      {showRemiAccounts && (
        <>
          <div className="fixed z-z-index-modal flex items-center justify-center top-left-base left-left-base w-width-full h-height-full  bg-opacity-dark-opacity">
            <LargePopupRedirect
              headerTitle={
                remType === "remitterUnmatch"
                  ? "Unmatch remitter accounts"
                  : remType === "remitterMatch"
                    ? "Match remitter accounts"
                    : "Remitter accounts"
              }
              headersubtext={
                remType === "remitterUnmatch"
                  ? "Only matched active (pending & approved) accounts are enabled for selection."
                  : remType === "remitterMatch"
                    ? "Only unmatched active (pending & approved) accounts are enabled for selection."
                    : "All accounts matched to the transaction are listed below."
              }
              closeiconenabledBgColor="var(--primary-nav)"
              closeiconisLoading={false}
              closeiconhandleFunction={() => {
                if (!matchButton) {
                  setMatchRemiId("");
                  setSelectedCardIds([]);
                  setSelectStatementRow([]);
                }
                setTotalRemiAccount("");
                setUnmatchRemiId("");
                setRemType("");
                setShowRemiAccounts(false);
              }}
              closeicon={ICONS?.CLOSE}
              closeiconhoverOption="white"
              closeiconbtnType={"button"}
              closeiconisDisabled={false}
              smallpopupsubtext="Leaving this page will exit from the current flow."
              closeicondisabledBgColor={""}
              closeiconbuttonRef={null}
              closeicontitle={"Close"}
              btnType={
                remType === "remitterUnmatch"
                  ? "Unmatch"
                  : remType === "remitterMatch"
                    ? "Match"
                    : "Confirm"
              }
              handleFunction={() => {
                if (remType === "remitterUnmatch") {
                  if (
                    selectedCardIds?.length >
                    GlobalConfiguration.lengthCheckZero
                  ) {
                    if (
                      services?.find(
                        (service) =>
                          service === "RMapping" || service === "Admin",
                      ) !== undefined
                    ) {
                      handleUnMatchStatement(selectedCardIds);
                    } else {
                      navigate("/feature_not_assigned", {
                        state: {
                          unavailableService: "RMapping",
                        },
                      });
                    }
                  }
                } else {
                  // const uniqueIds = selectedCardIds.filter(
                  //   (id) => !matchRemiId.includes(id),
                  // );
                  if (
                    selectedCardIds?.length >
                    GlobalConfiguration.lengthCheckZero
                  ) {
                    if (
                      services?.find(
                        (service) =>
                          service === "AMapping" || service === "Admin",
                      ) !== undefined
                    ) {
                      handleMatchStatement(selectedCardIds);
                    } else {
                      navigate("/feature_not_assigned", {
                        state: {
                          unavailableService: "AMapping",
                        },
                      });
                    }
                  }
                }
              }}
              enabledBgColor={
                selectedCardIds?.length > GlobalConfiguration.lengthCheckZero
                  ? "var(--positive-act)"
                  : "var(--text-disabled)"
              }
              hoverOption={"dark"}
              outLineColor={""}
              enabledTextColor={"var(--text-primary)"}
              isDisabled={
                !selectedCardIds?.length > GlobalConfiguration.lengthCheckZero
              }
              disabledTextColor={""}
              isLoading={unmatchLoader || matchLoader ? true : false}
              disabledBgColor={""}
              fullWidthRequired={true}
              isbottomSectionneed={
                remType === "remitterUnmatch" || remType === "remitterMatch"
              }
              bottomHeaderTextNeed={true}
              confirmbtnrequired={
                remType === "remitterUnmatch" || remType === "remitterMatch"
              }
              inActiveVariantNeeded
              bottomHeaderText={
                remType === "remitterUnmatch"
                  ? "To unmatch the transactions, select the accounts listed above and click “Unmatch”. The selected accounts will be unmatched with the transactions."
                  : remType === "remitterMatch"
                    ? "To match the transactions, select the accounts listed above and click “Match”. The selected accounts will be matched with the transactions."
                    : "To match the transactions, select the accounts listed above and click “Confirm”. The selected accounts will be matched with the transactions."
              }
              btnText={
                remType === "remitterUnmatch"
                  ? "Unmatch"
                  : remType === "remitterMatch"
                    ? "Match"
                    : "Confirm"
              }
              isfullViewrequired={remType === "remitterMatch" && true}
              fullviewbtnText="Register a new account"
              redirectHeader="Register a new account"
              smallPopupHeader={"Confirm leaving this page?"}
              fullviewhandleFunction={() => {
                navigate("/remitter_account_dashboard/create_remitter_account");
              }}
              redirectIcon={
                "https://q2pay.in/new_assets/common/settings/add_button_white.svg"
              }
            >
              <RemitterAccountViewAll
                remid={
                  totalRemiAccount?.length > GlobalConfiguration.lengthCheckZero
                    ? totalRemiAccount?.[0]
                    : unmatchRemiId?.length >
                        GlobalConfiguration.lengthCheckZero
                      ? unmatchRemiId
                      : matchRemiId?.length >
                          GlobalConfiguration.lengthCheckZero
                        ? matchRemiId
                        : ""
                }
                type={"RemitterAcc"}
                remType={remType}
                remiAcoountId={remiAcoountId}
                onCardNavigate={
                  remType !== "remitterUnmatch" &&
                  remType !== "remitterMatch" &&
                  handleCardNavigate
                }
                handleConfirmBtnClick={(e) => {}}
                selectedCardIds={selectedCardIds}
                setSelectedCardIds={setSelectedCardIds}
                cardType={
                  remType === "remitterUnmatch" || remType === "remitterMatch"
                    ? "matchRemAcc"
                    : ""
                }
                bottomHeaderText={
                  remType === "remitterUnmatch"
                    ? "To unmatch the transactions, select the accounts listed above and click “Confirm.” The selected accounts will be unmatched with the transactions."
                    : remType === "remitterMatch"
                      ? "To match the transactions, select the accounts listed above and click “Confirm.” The selected accounts will be matched with the transactions."
                      : "To match the transactions, select the accounts listed above and click “Confirm.” The selected accounts will be matched with the transactions."
                }
                createDisabled={false}
                showModalPopup={true}
                propType={"ownerStatement"}
              />
            </LargePopupRedirect>
          </div>
        </>
      )}
      {showDescriptionPopup && (
        <div
          style={{ zIndex: "var(--z-index-max)" }}
          className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center bg-opacity-dark-opacity"
        >
          <SmallPopupWithInput
            headerTitle="Description"
            headerFontColor="text-primary"
            headerFontWeight="semibold"
            textSize="font-md"
            subtext="Provide custom description."
            inputIsFullWidth={true}
            inputBgColor="var(--primary-bg)"
            inputPlaceholder="Description"
            // noteText="Minimum 10 characters required."
            bulletPoints={[
              "This description will be used for easier tracking and reconciliation of transaction entries.",
            ]}
            inputFgColor={
              description?.length
                ? "var(--text-primary)"
                : "var(--text-secondary)"
            }
            inputVariant={computeVariant(description, isFocused)}
            inputOnFocus={(e) => setIsFocused(true)}
            inputOnBlur={(e) => setIsFocused(false)}
            inputValue={description}
            inputFontKind="medium"
            inputOnInput={(e) => {
              // if (
              //   e.target.value?.replace(/\s+/g, " ").trimStart()?.length <=
              //   GlobalConfiguration.inputMaxLength
              // )
              //   setDescription(
              //     e.target.value?.replace(/\s+/g, " ").trimStart(),
              //   );

              const sanitizedValue = e.target.value
                .replace(/\s+/g, " ")
                .replace(/^\s/, "")
                .slice(0, 150);

              setDescription(sanitizedValue);
            }}
            btnOneText="Cancel"
            btnOneBtnType="button"
            btnOneHandleFunction={() => {
              if (!ownerAllAccAddDescriptionLoading) {
                setShowDescriptionPopup(false);
                setDescription("");
                setCurrentDescription({});
              }
            }}
            btnOneEnabledBgColor="transparent"
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneIsDisabled={ownerAllAccAddDescriptionLoading}
            btnOneHoverOption="white"
            btnTwoText={
              currentDescription?.description?.length ? "Confirm" : "Add"
            }
            btnTwoBtnType="button"
            btnTwoHandleFunction={async () => {
              if (!ownerAllAccAddDescriptionLoading) {
                let response = await dispatch(
                  addStatementDescription({
                    id: currentDescription.acc_id,
                    statement_entry_id:
                      currentDescription.account_statement_entry_id,
                    description: description,
                  }),
                );

                if (response?.payload?.status) {
                  dispatch(
                    updateStatementData({
                      description,
                      account_statement_entry_id:
                        currentDescription.account_statement_entry_id,
                    }),
                  );
                }

                setCurrentDescription({});
                setShowDescriptionPopup(false);
                setDescription("");
                setIsEditDescription(false);
              }
            }}
            btnTwoEnabledBgColor="var(--positive-act)"
            btnTwoDisabledBgColor="var(--text-disabled)"
            btnTwoDisabledTextColor="var(--text-primary)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={
              (!isEditDescription && !description?.length) ||
              description === currentDescription?.description
            }
            btnTwoIsLoading={ownerAllAccAddDescriptionLoading}
            btnTwoIsLoaderNeeded={true}
            btnTwoHoverOption="black"
            btnTwoInActiveVariantNeeded={true}
          />
        </div>
      )}

      {openMatchPopup && (
        <>
          <div style={{ zIndex: "var(--z-index-modal)" }}>
            <RemitAccountViewAllPopup
              id={remiAcoountId}
              propType={"ownerStatement"}
              type={"RemitterAcc"}
              headerTitle={"Match remitter accounts"}
              headersubtext={
                "Only unmatched active (pending & approved) accounts are enabled for selection."
              }
              closePopup={() => setOpenMatchPopup(false)}
              handleConfirmBtnClick={(e) => {
                handleMatchStatement(e);
              }}
              btnText={"Match"}
              cardType={"matchRemAcc"}
              bottomHeaderText={
                "To match the transactions, select the accounts listed above and click “Match”. The selected accounts will be matched with the transactions."
              }
              isfullViewrequired={true}
              fullviewbtnText="Register a new account"
              redirectHeader="Register a new account"
              smallPopupHeader={"Confirm leaving this page?"}
              fullviewhandleFunction={() => {
                navigate("/remitter_account_dashboard/create_remitter_account");
              }}
              redirectIcon={
                "https://q2pay.in/new_assets/common/settings/add_button_white.svg"
              }
              createDisabled={false}
              showModalPopup={true}
            />
          </div>
        </>
      )}
      {showConfirmPopup && (
        <div
          style={{ zIndex: "var(--z-index-modal)" }}
          className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center bg-opacity-dark-opacity"
        >
          <SmallPopup
            headerTitle="Proceed to upload statement?"
            headerFontWeight="semibold"
            headerFontColor="text-primary"
            textSize="font-md"
            subtext="This action will exit from from current flow."
            btnOneText="Cancel"
            btnOneBtnType="button"
            btnOneHandleFunction={() => setShowConfirmPopup(false)}
            btnOneEnabledBgColor="transparent"
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneIsDisabled={false}
            btnOneHoverOption="white"
            btnTwoText="Proceed"
            btnTwoBtnType="button"
            btnTwoHandleFunction={() =>
              navigate("/owner_account_dashboard/upload_bulk_bank_statement", {
                state: {
                  ownerBankAccountNo: props?.ownerDetailData?.bank_acc_no,
                  ownerBankIFSC: props?.ownerDetailData?.ifsc_code,
                  ownerBankLogo: props?.ownerDetailData?.ifsc_code,
                  bank_name: props?.ownerDetailData?.bank_name,
                  ownerBankAccountName: props?.ownerDetailData?.bank_name,
                },
              })
            }
            btnTwoEnabledBgColor="var(--brand-feedback-positive-action)"
            btnTwoEnabledTextColor="var(--brand-content-text-default)"
            btnTwoIsDisabled={false}
            btnTwoHoverOption="black"
          />
        </div>
      )}
      {showOwnerDetailPopup && (
        <LargePopupRedirect
          headerTitle="Owner account details"
          closeiconhandleFunction={() => setShowOwnerDetailPopup(false)}
        >
          <OwnerDetailsPage
            onClosed={() => setShowOwnerDetailPopup(false)}
            popType={"ownerStatement"}
            ownerDetailId={ownerDetailId}
          />
        </LargePopupRedirect>
      )}
      {showOwnerPopup && (
        <div
          style={{ zIndex: "var(--z-index-modal)" }}
          className="fixed top-top-base left-left-base w-width-full h-height-full bg-Primary-black bg-opacity-light-opacity"
        >
          <OwnerAccountPopUp
            setIsSidebarOpen={filterOpen}
            setOpenOwner={() => {
              setaccountnumberstate(accountNumber);
              setShowOwnerPopup(false);
            }}
            onClosed={() => {
              setAccountNumber(accountnumberstate);
              setShowOwnerPopup(false);
            }}
            accountNumber={accountNumber}
            setAccountNumber={setAccountNumber}
            accountnumberstate={accountnumberstate}
            setaccountnumberstate={setaccountnumberstate}
            multiSelect={true}
            setDefaultAccountNumber={setDefaultAccountNumber}
            accountDefaultNumber={accountDefaultNumber}
            flow={"txnViewAll"}
            popType={"ownerStatement"}
          />
        </div>
      )}
      <div
        className={` bg-primary-bg flex flex-col ${
          props?.popType === "remitterBankStatement" && "h-full"
        }  overflow-hidden ${
          props?.popType === "ownerStatement" ||
          props?.popType === "remitterBankStatement"
            ? " flex-1"
            : "h-full-height"
        }`}
        style={{
          overflow: filterOpen && "hidden",
          overflowY: showCalendar && "overlay",
        }}
      >
        <div
          className={`hidden ${
            props?.popType == "ownerStatement" ||
            props?.popType === "remitterBankStatement"
              ? "hidden"
              : "Qsmd:block"
          } `}
          style={{
            minHeight:
              props?.popType == "ownerStatement" ||
              props?.popType === "remitterBankStatement"
                ? "var(--navbar-height)"
                : "var(--navbar-breadcrumb-height)",
            backgroundColor: "var(--primary-nav)",
            zIndex: "var(--z-index-header)",
          }}
        ></div>

        <div className=" shadow-box-shadow-bottom z-z-index-content">
          {" "}
          <StatementTopNavComponent
            loading={false}
            topNavCtaBtn1Props={
              matchButton
                ? {
                    btnText:
                      selectStatementRow?.length >
                      GlobalConfiguration.lengthCheckZero
                        ? "Clear"
                        : "Cancel",
                    btnType: "button",
                    enabledBgColor: "var(--primary-nav-act)",
                    handleFunction: (e) => {
                      setUnMatchStatement("");
                      setMatchStatement("");

                      if (
                        selectStatementRow?.length >
                        GlobalConfiguration.lengthCheckZero
                      ) {
                        setSelectStatementRow([]);
                      } else {
                        setFlowType("");
                        setRemType("");
                        setMatchButton(false);
                        setRemiAcoountId([]);
                        setMatchRemiId([]);
                        setTotalRemiAccount([]);
                        setSelectedCardIds([]);
                        setStatementTypeState("");
                        setSelectStatementType(false);
                        setSelectStatementRow([]);
                      }
                    },
                    enabledTextColor: "var(--text-primary)",
                    isDisabled: false,
                    hoverOption: "white",
                  }
                : undefined
            }
            downloadFileProps={
              !matchButton
                ? {
                    btnText: "Download statement",
                    dropdownOptions: ["XLSX", "CSV", "TSV", "PDF"],
                    icon: "https://q2pay.in/new_assets/common/view_all/download_statement.svg",
                    isDisabled:
                      props?.flow === "rejectStatementdetails"
                        ? true
                        : (type === "remitter_details"
                              ? getAssociatedConsolidatedData
                                  ?.owner_account_details?.[0]?.statement
                                  ?.length
                              : ownerAllAccStatementData
                                  ?.owner_account_details?.[0]?.statement
                                  ?.length) ===
                            GlobalConfiguration.lengthCheckZero
                          ? true
                          : !accountDefaultNumber.length ||
                            ownerAllAccStatementLoading ||
                            getAssociatedConsolidatedLoading,
                    handleFunction: (e) => {
                      if (props?.flow === "rejectStatementdetails") {
                        actionRestricted();
                      } else {
                        if (
                          ownerAllAccStatementData === null ||
                          ownerAllAccStatementData?.total_count ===
                            GlobalConfiguration.lengthCheckZero
                        ) {
                          e.stopPropagation();
                          return;
                        } else {
                          downloadStatement();
                        }
                      }
                    },
                    selectedOption: selectedType,
                    setSelectedOption: setSelectedType,
                  }
                : false
            }
            topNavCtaBtn2Props={
              matchButton
                ? {
                    btnText: matchCondition ? "Match" : "Confirm",
                    isLoading: matchLoader,
                    isLoaderNeeded: true,
                    btnType: "button",
                    enabledBgColor:
                      selectStatementRow?.length >
                        GlobalConfiguration.lengthCheckZero && !matchCondition
                        ? "var(--text-primary)"
                        : matchCondition &&
                            selectStatementRow?.length >
                              GlobalConfiguration.lengthCheckZero
                          ? "var(--positive-act)"
                          : "var(--text-disabled)",
                    inActiveVariantNeeded: true,
                    handleFunction: (e) => {
                      if (hasMatchPermission) {
                        if (
                          selectStatementRow?.length >
                          GlobalConfiguration.lengthCheckZero
                        ) {
                          if (matchCondition) {
                            handleMatchStatement(matchId);
                          } else {
                            setShowRemiAccounts(true);
                            setRemType("remitterMatch");
                          }
                        }
                      } else {
                        navigate("/feature_not_assigned", {
                          state: {
                            unavailableService: "AMapping",
                          },
                        });
                      }
                    },
                    enabledTextColor:
                      selectStatementRow?.length >
                        GlobalConfiguration.lengthCheckZero && !matchCondition
                        ? "var(--primary-bg)"
                        : matchCondition &&
                            selectStatementRow?.length >
                              GlobalConfiguration.lengthCheckZero
                          ? "var(--text-primary)"
                          : "var(--text-primary)",
                    isDisabled: !hasMatchPermission
                      ? true
                      : selectStatementRow?.length ===
                        GlobalConfiguration.lengthCheckZero,
                    hoverOption: "black",
                  }
                : false
            }
            BottomSubTextVaraint={"primary"}
            BottomHeader={
              matchButton ? (
                <>
                  Select transactions to match to
                  <span
                    className={`${remitterName ? "font-semibold" : "font-normal"} ml-margin-xs`}
                  >
                    {remitterName || "remitter accounts"}
                  </span>
                  .
                </>
              ) : (
                `As on ${new Date()
                  .toLocaleDateString("en-GB", {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                  })
                  .replace(
                    /(\w{3}) (\d{4})/,
                    "$1, $2",
                  )} - Statement update depends on availability from the bank.`
              )
            }
            selectionText={`Transactions selected : ${totalSelectedCount}`}
            selectionBtnProps={{
              btnText: `Select up to ${pageSize}`,

              btnType: "button",

              handleFunction: () => {
                if (matchLoader) {
                  return;
                } else {
                  const statements =
                    type === "remitter_details" ||
                    props?.flow === "rejectStatementdetails"
                      ? getAssociatedConsolidatedData?.statement
                      : ownerAllAccStatementData?.statement;

                  const visibleRows =
                    statements?.map((item, index) => ({
                      rowId:
                        item?.account_statement_entry_id ||
                        item?.id ||
                        `${currentPage}-${index}`,
                      statement: item,
                    })) || [];

                  if (shouldClearPreviousSelection) {
                    setSelectStatementRow(selectedBankStatement || []);

                    setSelectedStatementRemitters({});

                    const additionalIds = Array.isArray(remiAcoountId)
                      ? remiAcoountId
                      : remiAcoountId
                        ? [remiAcoountId]
                        : [];

                    setMatchRemiId(additionalIds);

                    setSelectedCardIds(additionalIds);

                    return;
                  }
                  setSelectStatementRow((prev) => {
                    const selectableRows = visibleRows.filter(
                      ({ rowId }) => !selectedBankStatement?.includes(rowId),
                    );

                    const selectableRowIds = selectableRows.map(
                      ({ rowId }) => rowId,
                    );

                    const totalUserSelectedCount = prev.filter(
                      (id) => !selectedBankStatement?.includes(id),
                    ).length;

                    const currentPageSelectedCount = selectableRowIds.filter(
                      (id) => prev.includes(id),
                    ).length;

                    const shouldClearAll =
                      selectableRowIds.length > 0 &&
                      currentPageSelectedCount === selectableRowIds.length;

                    if (shouldClearAll) {
                      setSelectedStatementRemitters({});

                      const additionalIds = Array.isArray(remiAcoountId)
                        ? remiAcoountId
                        : remiAcoountId
                          ? [remiAcoountId]
                          : [];

                      setMatchRemiId(additionalIds);
                      setSelectedCardIds(additionalIds);

                      return [];
                    }

                    const protectedRows = prev.filter((id) =>
                      selectedBankStatement?.includes(id),
                    );

                    const rowsToSelect = selectableRowIds
                      .filter((id) => !prev.includes(id))
                      .slice(0, remainingSelection);

                    const updatedRows = [
                      ...new Set([
                        ...protectedRows,
                        ...prev.filter(
                          (id) => !selectedBankStatement?.includes(id),
                        ),
                        ...rowsToSelect,
                      ]),
                    ];

                    setSelectedStatementRemitters((prevRemitters) => {
                      const updatedRemitters = {};

                      Object.keys(prevRemitters || {}).forEach((key) => {
                        if (selectedBankStatement?.includes(key)) {
                          updatedRemitters[key] = prevRemitters[key];
                        }
                      });

                      selectableRows.forEach(({ rowId, statement }) => {
                        updatedRemitters[rowId] =
                          statement?.remitter_accounts?.map(
                            (acc) => acc.remitter_account_id,
                          ) || [];
                      });

                      const additionalIds = Array.isArray(remiAcoountId)
                        ? remiAcoountId
                        : remiAcoountId
                          ? [remiAcoountId]
                          : [];

                      const uniqueIds = [
                        ...new Set([
                          ...Object.values(updatedRemitters).flat(),
                          ...additionalIds,
                        ]),
                      ];

                      setMatchRemiId(uniqueIds);

                      return updatedRemitters;
                    });

                    return updatedRows;
                  });

                  setSelectedCardIds(
                    Array.isArray(remiAcoountId)
                      ? remiAcoountId
                      : remiAcoountId
                        ? [remiAcoountId]
                        : [],
                  );
                }
              },

              enabledBgColor:
                isAllVisibleSelected && !loading && !ownerAllAccStatementLoading
                  ? "var(--positive-bg)"
                  : "var(--primary-nav-act)",

              hoverOption: isAllVisibleSelected ? "black" : "white",

              enabledTextColor: "var(--text-primary)",

              isDisabled:
                getAssociatedConsolidatedLoading ||
                ownerAllAccStatementLoading ||
                loading ||
                matchLoader,

              icon:
                isAllVisibleSelected &&
                !loading &&
                !ownerAllAccStatementLoading &&
                !getAssociatedConsolidatedLoading
                  ? ICONS.SELECTED_WITH_GREEN_CIRCLE
                  : ICONS.SELECT_ALL_WITH_WHITE_OUTLINE_CIRCLE,
            }}
            // matchBtnProps={
            //   matchButton
            //     ? {
            //         btnText: "Matched : 0",
            //         btnType: "button",
            //         handleFunction: () => {
            //           if (matchStatement === "") {
            //             setMatchStatement("Matched");
            //             setUnMatchStatement("");
            //           } else {
            //             setMatchStatement("");
            //           }
            //         },
            //         enabledBgColor:
            //           matchStatement === ""
            //             ? "var(--primary-nav-act)"
            //             : "var(--primary-card)",
            //         hoverOption: "white",
            //         enabledTextColor: "var(--text-primary)",
            //         isDisabled: false,
            //         icon:
            //           matchStatement === ""
            //             ? ICONS?.FILTER
            //             : ICONS.CLOSE_WITH_BLUE_CIRCLE,
            //         imgColor:
            //           matchStatement === "" ? "var(--text-primary)" : "",
            //       }
            //     : undefined
            // }
            // unmatchBtnProps={
            //   matchButton
            //     ? {
            //         btnText: "Unmatched : 0",
            //         btnType: "button",
            //         handleFunction: () => {
            //           if (unmatchStatement === "") {
            //             setUnMatchStatement("Unmatched");
            //             setMatchStatement("");
            //           } else {
            //             setUnMatchStatement("");
            //           }
            //         },
            //         enabledBgColor:
            //           unmatchStatement === ""
            //             ? "var(--primary-nav-act)"
            //             : "var(--primary-card)",
            //         hoverOption: "white",
            //         enabledTextColor: "var(--text-primary)",
            //         isDisabled: false,
            //         icon:
            //           unmatchStatement === ""
            //             ? ICONS?.FILTER
            //             : ICONS.CLOSE_WITH_BLUE_CIRCLE,
            //         imgColor:
            //           unmatchStatement === "" ? "var(--text-primary)" : "",
            //       }
            //     : undefined
            // }
            iconRoundProps={
              !matchButton
                ? {
                    enabledBgColor: "var(--primary-bg)",
                    isLoading: false,
                    handleFunction: (e) => {
                      if (props?.flow === "rejectStatementdetails") {
                        actionRestricted();
                      } else {
                        setShowConfirmPopup(true);
                      }
                    },
                    isDisabled:
                      props?.flow === "rejectStatementdetails" ? true : false,
                    icon: ICONS.UPLOAD,
                    title: "Upload Statement",
                    // imgColor: "var(--text-primary)",
                    hoverOption: "white",
                  }
                : undefined
            }
            matchRemitterProps={
              !matchButton && props?.flow !== "rejectStatementdetails"
                ? {
                    handleFunction: () => {
                      if (
                        props?.flow === "rejectStatementdetails" ||
                        props?.flow === "ownerDetail"
                      ) {
                        actionRestricted();
                      } else {
                        if (hasMatchPermission) {
                          if (
                            !accountDefaultNumber.length ||
                            ownerAllAccStatementLoading
                          ) {
                            return;
                          } else {
                            setMatchButton(!matchButton);
                            setStatementTypeState("Credit");
                          }
                        } else {
                          navigate("/feature_not_assigned", {
                            state: {
                              unavailableService: "AMapping",
                            },
                          });
                        }
                      }
                    },
                    isDisabled: !hasMatchPermission
                      ? true
                      : props?.flow === "rejectStatementdetails" ||
                          props?.flow === "ownerDetail"
                        ? true
                        : props?.popType
                          ? true
                          : !accountDefaultNumber.length ||
                            ownerAllAccStatementLoading,
                    enabledBgColor: "var(--primary-bg)",
                    isLoading: false,
                    imgColor: "var(--text-primary)",
                    hoverOption: "white",
                    buttonRef: null,
                    title:
                      "Match a remitter account to identify the source of credited transactions.",
                  }
                : undefined
            }
            isSelectionView={matchButton ? true : false}
            filteredSearchProps={{
              isFilterDisabled:
                props?.statement_entry_id || !accountNumber.length,
              isColumnDisabled: props?.statement_entry_id
                ? true
                : !accountDefaultNumber.length,
              setShowInnerSearchBar: setShowInnerSearchBar,
              showSearchBar: showSearchBar,
              isSearchDisabled:
                props?.statement_entry_id || !accountNumber.length,

              onSearchInput: handleSearch,
              searchText: searchUserTextDebounce,
              searchPlaceholder: "Search consolidated bank statement",
              columnOptions: [
                { colName: "Bank", colWidth: "column-width-sm", flex: 0 },

                {
                  colName: "Transaction date and time",
                  colWidth: "column-width-lg",
                  flex: 1,
                },

                {
                  colName: "Value date",
                  colWidth: "column-width-md",
                  flex: 0,
                },

                {
                  colName: "Bank reference number",
                  colWidth: "column-width-md",
                  flex: 0,
                },

                {
                  colName: "Narration",
                  colWidth: "column-width-md",
                  flex: 0,
                },

                {
                  colName: "Type",
                  colWidth: "column-width-sm",
                  flex: 0,
                },

                {
                  colName: "Amount",
                  colWidth: "column-width-md",
                  flex: 0,
                },

                {
                  colName: "Debit amount",
                  colWidth: "column-width-md",
                  flex: 0,
                },

                {
                  colName: "Credit amount",
                  colWidth: "column-width-md",
                  flex: 0,
                },

                {
                  colName: "Closing balance",
                  colWidth: "column-width-md",
                  flex: 0,
                },

                {
                  colName: "Account number",
                  colWidth: "column-width-lg",
                  flex: 1,
                },

                {
                  colName: "IFSC code",
                  colWidth: "column-width-md",
                  flex: 0,
                },

                {
                  colName: "Statement source",
                  colWidth: "column-width-lg",
                  flex: 0,
                },

                // {
                //   colName: "Source account number",
                //   colWidth: "column-width-lg",
                //   flex: 1,
                // },

                {
                  colName: "Name",
                  colWidth: "column-width-md",
                  flex: 0,
                },

                // {
                //   colName: "Generated on",
                //   colWidth: "column-width-md",
                //   flex: 0,
                // },

                {
                  colName: "Description",
                  colWidth: "column-width-lg",
                  flex: 1,
                },

                {
                  colName: "Remitter account",
                  colWidth: "column-width-md",
                  flex: 0,
                },
              ],

              filterItems: [
                {
                  name: "Debit amount",
                  isMulti: false,
                  short_name: "Dr. Amt. -",
                  value: formatAmount(debiteAmount),
                  setValue: (val) => {
                    setDebitAmount(val);
                    // setSearchUserText(val);
                    // handleSubmit("search", val);
                  },
                  isDropdown: false,
                  isDisabled: matchButton
                    ? true
                    : creditAmount !== ""
                      ? true
                      : props?.popType === "ownerStatement" ||
                          props?.flow === "rejectStatementdetails"
                        ? true
                        : false,
                },
                {
                  name: "Credit amount",
                  short_name: "Cr. Amt. -",
                  isMulti: false,
                  value: formatAmount(creditAmount),
                  setValue: (val) => {
                    setCreditAmount(val);
                    // setSearchUserText(val);
                    // handleSubmit("search", val);
                  },
                  isDropdown: false,
                  isDisabled: debiteAmount !== "" ? true : false,
                  valueType: "string",
                },
              ],

              columnValue: additionalDetailColState,
              columnHandleChange: (val) => {
                handleAddDetail(val ? val : defaultAdditionalDetailCol);
              },
              isColumnDefaultDisabled:
                JSON.stringify(defaultAdditionalDetailCol) ===
                  JSON.stringify(additionalDetailColState) ||
                JSON.stringify(defaultAdditionalDetailCol) ===
                  JSON.stringify(additionalDetailColState),
              handleColumnDefault: () => {
                setAdditionalDetailsColState(defaultAdditionalDetailCol);
              },

              filters: [
                {
                  name: "Owner account",
                  filterType: "accountSelect",
                  btnProps: {
                    btnText: accountnumberstate.length
                      ? `${accountnumberstate.length} selected`
                      : "Select accounts",
                    enabledTextColor: "var(--text-primary)",
                    enabledBgColor: "var(--primary-nav-act)",
                    isDisabled:
                      props?.flow === "rejectStatementdetails" ||
                      props?.flow === "ownerDetail"
                        ? true
                        : false,
                    handleFunction: () => {
                      if (
                        props?.popType !== "ownerStatement" &&
                        props?.flow !== "ownerDetail"
                      ) {
                        if (props?.flow !== "rejectStatementdetails") {
                          setShowOwnerPopup(true);
                        }
                      }
                    },
                  },
                },

                {
                  name: "Amount range",
                  filterType: "amountRange",
                  variant: "single",
                  size: "small",
                  value: isAmtFilterApplied,
                  rangeValue: amountRangeFilter,
                  setShowAmtFilterDiv: setShowAmtFilterDiv,
                  setIsAmtFilterApplied: setIsAmtFilterApplied,
                  handleChange: (val) => {
                    if (typeof val === "function") {
                      setAmountRangeFilter((prev) => val(prev));
                      return;
                    }

                    if (val && typeof val === "object") {
                      const nextMin = val?.min ?? "";
                      const nextMax = val?.max ?? "";
                      setAmountRangeFilter({
                        min: nextMin,
                        max: nextMax,
                      });
                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      handleSubmit("min_amount", nextMin);
                      handleSubmit("max_amount", nextMax);
                      return;
                    }

                    setAmountRangeFilter({ min: "", max: "" });
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    handleSubmit("min_amount", "");
                    handleSubmit("max_amount", "");
                  },
                },

                {
                  name: "Statement source",
                  filterType: "dropdown",
                  variant: "single",
                  options: ["Uploaded manually", "Fetch from bank"],
                  size: "small",
                  value: sourceState,
                  dropdownPlaceHolder: "Select source",
                  isDisabled: props?.flow === "rejectStatementdetails",

                  statusPop: true,
                  handleChange: (value) => {
                    if (props?.flow !== "rejectStatementdetails") {
                      setSourceState(value);
                    }
                  },
                },

                {
                  name: "Transaction type",
                  filterType: "dropdown",
                  variant: "single",
                  options: ["Credit", "Debit"],
                  size: "small",
                  value: statementTypeState,
                  dropdownPlaceHolder: "Select type",
                  isDisabled:
                    matchButton || props?.flow === "rejectStatementdetails"
                      ? true
                      : false,

                  statusPop: true,
                  handleChange: (value) => {
                    if (
                      !matchButton &&
                      props?.flow !== "rejectStatementdetails"
                    ) {
                      setStatementTypeState(value);
                    }
                  },
                },
                {
                  name: "Date range",
                  filterType: "calender",
                  variant: "range",
                  size: "small",
                  value: startDateState && endDateState,
                  isDisable: false,
                  startDate: startDateState
                    ? new Date(
                        startDateState * IntervalConfiguration.intervalMedium,
                      )
                    : startDateState,

                  endDate: endDateState
                    ? new Date(
                        endDateState * IntervalConfiguration.intervalMedium,
                      )
                    : endDateState,

                  handleChange: (date) => {
                    setIsDateConfirm(date ? true : false);

                    handleDateChange(date);
                  },
                },
                {
                  name: "Match status",
                  filterType: "dropdown",
                  variant: "single",
                  options: ["Matched", "Unmatched"],
                  size: "small",
                  value: matchStatement || unmatchStatement,
                  dropdownPlaceHolder: "Select status",
                  isDisabled: props?.flow === "rejectStatementdetails",

                  statusPop: true,
                  handleChange: (value) => {
                    if (value === "Matched") {
                      setMatchStatement(value);
                      setUnMatchStatement("");
                    } else {
                      setUnMatchStatement(value);
                      setMatchStatement("");
                    }
                    move();
                  },
                },
              ],
              isFilterClearAllDisabled:
                props?.flow === "rejectStatementdetails"
                  ? !amountRangeFilter?.min &&
                    !amountRangeFilter?.max &&
                    !startDateState &&
                    !endDateState
                  : !matchStatement?.length &&
                    !unmatchStatement?.length &&
                    !sourceState?.length &&
                    !amountRangeFilter?.min &&
                    !amountRangeFilter?.max &&
                    startDateState === defaultStartDate &&
                    endDateState === defaultEndDate &&
                    !isDateConfirm,

              isSearchClearAllDisabled: false,
              inputData: inputData,
              active: active,

              setActive: setActive,
              loading: ownerAllAccStatementLoading,
              setLoading: setLoadingData,
              isShowFilter: true,
              isShowColumn: true,
              loadingData: loadingData,
            }}
            openFilter={openDateFilter}
            setOpenFilter={setopenDateFilter}
            ispagination={
              (type === "remitter_details" ||
              props?.flow === "rejectStatementdetails"
                ? getAssociatedConsolidatedData?.statement?.length
                : ownerAllAccStatementData?.statement?.length) >
                GlobalConfiguration.lengthCheckZero && matchButton
            }
          />
        </div>

        <div
          style={{
            position:
              showCalendar || filterOpen || showAdditionalDetails
                ? "absolute"
                : "relative",
            opacity:
              showCalendar || filterOpen || showAdditionalDetails
                ? "var(--dark-opacity)"
                : "var(--opcacity-none)",
            display:
              showCalendar || filterOpen || showAdditionalDetails
                ? "block"
                : "hidden",
            backgroundColor:
              showCalendar || showAdditionalDetails || filterOpen
                ? "var(--PopUp-BackDrop)"
                : "",
            height:
              showCalendar || filterOpen || showAdditionalDetails
                ? "var(--height-full)"
                : "0",
            width:
              showCalendar || filterOpen || showAdditionalDetails
                ? "var(--width-full)"
                : "0",
            zIndex: "var(--z-index-content)",
          }}
        ></div>

        <div
          ref={scrollRef}
          style={{
            backgroundColor: "var(--primary-bg)",
            overflowY: "hidden",
            scrollbarWidth: "none",
            overflowX: showInnerSearchBar
              ? "hidden"
              : type === "remitter_details" ||
                  props?.flow === "rejectStatementdetails"
                ? getAssociatedConsolidatedLoading ||
                  !getAssociatedConsolidatedData?.statement?.length
                  ? "hidden"
                  : "scroll"
                : ownerAllAccStatementLoading ||
                    !ownerAllAccStatementData?.statement?.length
                  ? "hidden"
                  : "scroll",
            marginBottom:
              getAssociatedConsolidatedLoading || ownerAllAccStatementLoading
                ? ""
                : props?.flow === "rejectStatementdetails" &&
                    getAssociatedConsolidatedData?.statement?.length ===
                      GlobalConfiguration.lengthCheckZero
                  ? ""
                  : (type === "remitter_details" ||
                      props?.flow === "rejectStatementdetails"
                        ? getAssociatedConsolidatedData?.statement?.length
                        : ownerAllAccStatementData?.statement?.length) >
                        GlobalConfiguration.lengthCheckZero &&
                      props?.flow !== "rejectStatementdetails"
                    ? "var(--pagination-height)"
                    : "",
            borderRadius: "inherit",
          }}
          className={`${
            props?.popType === "ownerStatement" ||
            props?.popType === "remitterBankStatement"
              ? "popupstatementviewallscrolls"
              : ""
          }  w-full  ${showInnerSearchBar ? " overflow-x-hidden" : "overflow-x-auto"} flex  flex-col statementviewallscroll relative z-z-index-base flex-1`}
        >
          <div
            style={{
              display:
                !(type === "remitter_details" ||
                props?.flow === "rejectStatementdetails"
                  ? getAssociatedConsolidatedData?.statement?.length
                  : ownerAllAccStatementData?.statement?.length) ||
                getAssociatedConsolidatedLoading ||
                ownerAllAccStatementLoading
                  ? "none"
                  : "block",
              background: !ownerAllAccStatementData?.statement?.length
                ? "var(--primary-bg)"
                : !getAssociatedConsolidatedData?.statement?.length
                  ? "var(--primary-bg)"
                  : "var(--primary-nav)",
              zIndex: openMatchPopup
                ? "var(--z-index-base)"
                : showInnerSearchBar ||
                    showConfirmPopup ||
                    showDescriptionPopup ||
                    showOwnerPopup ||
                    showOwnerDetailPopup
                  ? "var(--z-index-base)"
                  : showCalendar || filterOpen || showAdditionalDetails
                    ? "var(--z-index-base)"
                    : "var(--z-index-modal)",
              width:
                props?.popType == "ownerStatement" ||
                props?.popType === "remitterBankStatement"
                  ? "var(--popup-width)"
                  : "var(--width-full)",
              bottom:
                (props?.popType == "ownerStatement" ||
                  props?.popType === "remitterBankStatement") &&
                props?.flow !== "rejectStatementdetails"
                  ? "var(--bottom-sm)"
                  : "var(--bottom-base)",
              borderRadius:
                props?.popType == "ownerStatement" ||
                props?.popType === "remitterBankStatement"
                  ? " var(--border-radius-md)"
                  : "none",
              position:
                props?.popType === "remitterBankStatement" &&
                props?.flow !== "ownerDetail" &&
                "absolute",
              pointerEvents: showInnerSearchBar && "none",
            }}
            className={` fixed w-width-full   ${
              props?.popType == "ownerStatement" ||
              props?.popType === "remitterBankStatement"
                ? ""
                : ""
            }`}
          >
            <div
              className={` ${
                showInnerSearchBar &&
                " absolute opacity-light-opacity w-full h-full z-z-index-header bg-PopUp-BackDrop pointer-events-none "
              }`}
            ></div>{" "}
            <PaginationComponent
              handleSelect={handleSelect}
              selectedValue={selectedValue}
              data={
                ownerAllAccStatementData || getAssociatedConsolidatedData || []
              }
              pageSize={pageSize}
              dropdownOptions={dropdownOptions}
              handlePagination={handlePagination}
              currentPage={currentPage}
              setIsOpen={setIsOpen}
              typePopup={
                props?.popType == "ownerStatement" ||
                props?.flow === "ownerDetail"
                  ? true
                  : false
              }
            />
          </div>
          <div
            style={{
              marginBottom:
                props?.flow === "rejectStatementdetails" &&
                getAssociatedConsolidatedData?.total_count !==
                  GlobalConfiguration.lengthCheckZero &&
                "",
            }}
            className={`flex flex-1 ${
              showInnerSearchBar
                ? " pointer-events-none"
                : type === "remitter_details" ||
                    props?.flow === "rejectStatementdetails"
                  ? getAssociatedConsolidatedData?.statement?.length >
                    GlobalConfiguration.lengthCheckZero
                    ? "overflow-y-auto"
                    : ""
                  : ownerAllAccStatementData?.statement?.length >
                      GlobalConfiguration.lengthCheckZero
                    ? "overflow-y-auto"
                    : ""
            } flex-col`}
          >
            {showInnerSearchBar && (
              <>
                <div
                  className={`absolute top-top-base left-left-base h-full w-full overflow-x-hidden ${
                    ownerAllAccStatementLoading
                      ? "bg-PopUp-BackDrop opacity-dark-opacity"
                      : (type === "remitter_details" ||
                          props?.flow === "rejectStatementdetails"
                            ? getAssociatedConsolidatedData?.statement?.length
                            : ownerAllAccStatementData?.statement?.length) >
                          GlobalConfiguration.lengthCheckZero
                        ? "bg-PopUp-BackDrop opacity-dark-opacity"
                        : "opacity-light-opacity"
                  } pointer-events-none z-z-index-header overflow-hidden`}
                ></div>
              </>
            )}
            <div className="w-max min-w-full shadow-box-shadow-top z-z-index-content ">
              <div
                className={`OAS-table-div-container  ${
                  showCalendar
                    ? ""
                    : selectStatement
                      ? ""
                      : " z-z-index-content"
                }  `}
              >
                {matchButton && (
                  <>
                    {" "}
                    <div>
                      {" "}
                      <p
                        className={`text-font-xs px-padding-xl h-auto break-all py-padding-button-l border-r border-primary-bg text-text-secondary text-center`}
                      >
                        Select
                      </p>
                    </div>
                  </>
                )}

                {additionalDetailColState?.map((column, index) => {
                  return (
                    <>
                      <p
                        style={{
                          minWidth: `var(--${column.colWidth})`,
                          flex: `${column.flex}`,
                        }}
                        className={`text-font-xs px-padding-md h-auto break-all py-padding-button-l text-text-secondary text-center`}
                      >
                        {column.colName}
                      </p>
                      <div
                        style={{
                          display:
                            index === additionalDetailColState.length - 1
                              ? "none"
                              : "block",
                        }}
                        className="OAS-border-mid-div"
                      ></div>
                    </>
                  );
                })}
              </div>
            </div>

            {!accountNumber.length ? (
              <div className="h-height-full flex-col m-auto pb-padding-md  overflow-y-scroll justify-center items-center flex w-full">
                {showInnerSearchBar && (
                  <>
                    <div className="absolute top-top-base left-left-base h-full w-full overflow-x-hidden pointer-events-none bg-PopUp-BackDrop opacity-dark-opacity z-z-index-header overflow-hidden"></div>
                  </>
                )}
                <img
                  src={ICONS?.VIEW_CATEGORY_GRAPHICS}
                  alt="No accounts found"
                  className="w-graphic-width-sm Qsmd:w-graphic-width-md  h-graphic-square-height-sm Qsmd:h-graphic-square-height-md"
                />
                <p className="text-font-sm text-text-primary flex flex-col pt-padding-sm">
                  <span>
                    Select the accounts to view consolidated statement.
                  </span>
                </p>
                <div className="pt-padding-sm">
                  <PrimaryButton
                    enabledBgColor="var(--primary-act)"
                    btnText="Select accounts"
                    enabledTextColor="var(--text-primary)"
                    handleFunction={() => {
                      setShowOwnerPopup(true);
                    }}
                    buttonRef={selectAccountRef}
                    hoverOption="white"
                  />
                </div>
              </div>
            ) : getAssociatedConsolidatedLoading ||
              ownerAllAccStatementLoading ? (
              <div
                className={`absolute top-auto overflow-hidden flex h-full m-auto justify-center items-center ${
                  props?.popType === "ownerStatement"
                    ? "w-full-popup-width"
                    : "w-full-width"
                }`}
              >
                <img
                  src={ICONS?.LOADER_GIF}
                  className="h-loader-lg w-loader-lg flex-shrink-0"
                  alt=""
                />
              </div>
            ) : ownerAllAccStatementData?.total_count >
                GlobalConfiguration.lengthCheckZero ||
              (getAssociatedConsolidatedData?.statement?.length &&
                flowType !== "remitter_details_match_statement" &&
                selectStatementType !== "remitter_edit_match_statement") ? (
              <div
                ref={scrollTopRef}
                style={{
                  flex: "1",
                  overflowY: showInnerSearchBar
                    ? "hidden"
                    : type === "remitter_details" ||
                        props?.flow === "rejectStatementdetails"
                      ? getAssociatedConsolidatedLoading ||
                        getAssociatedConsolidatedData?.owner_account_details
                          ?.statement?.length
                      : ownerAllAccStatementLoading ||
                          ownerAllAccStatementData?.owner_account_details
                            ?.statement?.length
                        ? "hidden"
                        : "auto",
                }}
                className={`flex flex-col  ${showInnerSearchBar ? " overflow-y-hidden" : "overflow-y-scroll"} w-max min-w-full relative ${matchButton && "mb-margin-xl Qsmd:mb-margin-base pb-padding-md Qsmd:pb-padding-base"}  mt-margin-base`}
              >
                <div className={`flex flex-col relative `}>
                  {showInnerSearchBar && (
                    <>
                      <div className="absolute top-top-base left-left-base h-full w-full overflow-x-hidden pointer-events-none  opacity-dark-opacity z-z-index-header overflow-hidden"></div>
                    </>
                  )}
                  {(type === "remitter_details" ||
                  props?.flow === "rejectStatementdetails"
                    ? getAssociatedConsolidatedData?.statement
                    : ownerAllAccStatementData?.statement
                  )?.map((statement, index) => {
                    const rowId =
                      statement?.account_statement_entry_id ||
                      statement?.id ||
                      `${currentPage}-${index}`;

                    const isPreSelected = selectedBankStatement.includes(rowId);
                    const isSelected =
                      isPreSelected || selectStatementRow.includes(rowId);

                    return (
                      <div
                        onClick={() => {
                          if (!matchButton) return;

                          if (isPreSelected) {
                            CommonToast({
                              text: "Unmatching transactions are restricted in the matching flow.",
                              icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
                              variant: "var(--error)",
                            });
                            return;
                          }

                          const statementRemitterIds =
                            statement?.remitter_accounts?.map(
                              (itm) => itm.remitter_account_id,
                            ) || [];

                          const additionalIds = Array.isArray(remiAcoountId)
                            ? remiAcoountId
                            : remiAcoountId
                              ? [remiAcoountId]
                              : [];

                          const isSelected = selectStatementRow.includes(rowId);

                          const currentSelectedCount =
                            selectStatementRow.filter(
                              (id) => !selectedBankStatement?.includes(id),
                            ).length;

                          const maxLimit = Number(pageSize);

                          if (!isSelected && currentSelectedCount >= maxLimit) {
                            CommonToast({
                              text: "Maximum limit reached.",
                              icon: ICONS.ERROR_WITH_WHITE_CIRCLE,
                              variant: "var(--error)",
                              buttonNeeded: false,
                            });

                            return;
                          }

                          setSelectStatementRow((prev) =>
                            isSelected
                              ? prev.filter((id) => id !== rowId)
                              : [...prev, rowId],
                          );

                          setSelectedStatementRemitters((prev) => {
                            const updated = { ...prev };

                            if (isSelected) {
                              delete updated[rowId];
                            } else {
                              updated[rowId] = statementRemitterIds;
                            }

                            const uniqueIds = [
                              ...new Set([
                                ...Object.values(updated).flat(),
                                ...additionalIds,
                              ]),
                            ];

                            setMatchRemiId(uniqueIds);

                            return updated;
                          });

                          setSelectedCardIds(
                            Array.isArray(remiAcoountId)
                              ? remiAcoountId
                              : [remiAcoountId],
                          );
                        }}
                        className={`OAS-table-div-content     ${
                          matchLoader
                            ? "cursor-default opacity-light-opacity"
                            : matchButton && !isPreSelected
                              ? "cursor-pointer"
                              : "cursor-default"
                        }  ${
                          isSelected && matchButton
                            ? "bg-positive-bg  z-z-index-content"
                            : isSelected
                              ? "global-hover-black"
                              : matchButton
                                ? "global-hover-white"
                                : ""
                        }   ${isPreSelected && matchButton && "opacity-light-opacity"}`}
                      >
                        {matchButton && (
                          <>
                            {" "}
                            <div className="px-padding-xl flex items-center justify-center">
                              <img
                                src={
                                  isSelected
                                    ? ICONS.SELECTED_WITH_GREEN_CIRCLE
                                    : ICONS.SELECT_ALL_WITH_WHITE_OUTLINE_CIRCLE
                                }
                                alt="selection"
                                className="h-icon-sm ml-margin-sm"
                              />
                            </div>
                          </>
                        )}
                        {additionalDetailColState?.some(
                          (x) => x.colName === "Bank",
                        ) && (
                          <>
                            <div className="text-font-xs flex-0 pr-padding-md pl-padding-lg h-auto py-padding-xs  text-text-secondary text-center min-w-column-width-sm w-column-width-sm flex items-center">
                              <div className="py-padding-button-s px-padding-sm rounded-border-radius-md bg-text-primary flex justify-center items-center">
                                <div className="w-banklogo-width-sm h-banklogo-height-sm flex-shrink-0">
                                  <IfscCodeMapper
                                    ifscCode={statement?.ifsc_code}
                                  />
                                </div>
                              </div>
                            </div>
                          </>
                        )}
                        {additionalDetailColState?.some(
                          (x) => x.colName === "Transaction date and time",
                        ) && (
                          <>
                            <p
                              className={
                                "text-font-xs px-padding-md h-auto break-all flex items-center justify-center py-padding-xs flex-0 text-text-primary text-center w-column-width-md min-w-column-width-md"
                              }
                            >
                              {formatDateandTime(
                                new Date(statement?.transaction_date),
                                true,
                              ) || "-"}
                            </p>
                          </>
                        )}
                        {additionalDetailColState?.some(
                          (x) => x.colName === "Value date",
                        ) && (
                          <>
                            <p
                              className={
                                "text-font-xs px-padding-md h-auto break-all flex items-center justify-center py-padding-xs flex-0 text-text-primary text-center w-column-width-md min-w-column-width-md"
                              }
                            >
                              {formatDateandTime(
                                new Date(statement?.value_date),
                              ) || "-"}
                            </p>
                          </>
                        )}
                        {additionalDetailColState?.some(
                          (x) => x.colName === "Bank reference number",
                        ) && (
                          <>
                            <p
                              className={
                                "text-font-xs px-padding-md h-auto break-all flex items-center justify-center py-padding-xs flex-0 text-text-primary text-center w-column-width-lg min-w-column-width-lg"
                              }
                            >
                              {statement?.bank_reference || "-"}
                            </p>
                          </>
                        )}
                        {additionalDetailColState?.some(
                          (x) => x.colName === "Narration",
                        ) && (
                          <>
                            <p
                              className={
                                "text-font-xs px-padding-md h-auto break-all flex items-center justify-center py-padding-xs flex-1 text-text-primary text-center w-column-width-lg min-w-column-width-lg"
                              }
                            >
                              {linkIdentifier(statement?.narration) || "-"}
                            </p>
                          </>
                        )}
                        {additionalDetailColState?.some(
                          (x) => x.colName === "Type",
                        ) && (
                          <>
                            <div
                              className={
                                "text-font-xs px-padding-md h-auto break-all flex items-center justify-center py-padding-xs flex-0 text-text-primary text-center w-column-width-md min-w-column-width-md"
                              }
                            >
                              {statement?.credit_debit || "-"}
                            </div>
                          </>
                        )}
                        {additionalDetailColState?.some(
                          (x) => x.colName === "Amount",
                        ) && (
                          <>
                            <div
                              className={
                                "text-font-xs px-padding-md h-auto break-all flex items-center justify-center py-padding-xs flex-0 text-text-primary text-center w-column-width-md min-w-column-width-md"
                              }
                              style={{
                                color: "var(--text-primary)",
                                textAlign: "right",
                                justifyContent: "end",
                              }}
                            >
                              INR{" "}
                              <FormatAmount price={Number(statement?.amount)} />
                            </div>
                          </>
                        )}
                        {additionalDetailColState?.some(
                          (x) => x.colName === "Debit amount",
                        ) && (
                          <>
                            <div
                              className={
                                "text-font-xs px-padding-md h-auto break-all flex items-center justify-center py-padding-xs flex-0 text-text-primary text-center w-column-width-md min-w-column-width-md"
                              }
                              style={{
                                color: "var(--failed)",
                                textAlign: "right",
                                justifyContent: "end",
                              }}
                            >
                              {statement.credit_debit == "Debit" ? (
                                <>
                                  INR{" "}
                                  <FormatAmount
                                    price={Number(statement?.amount)}
                                  />
                                </>
                              ) : (
                                "-"
                              )}
                            </div>
                          </>
                        )}
                        {additionalDetailColState?.some(
                          (x) => x.colName === "Credit amount",
                        ) && (
                          <>
                            <div
                              className={
                                "text-font-xs px-padding-md h-auto break-all flex items-center justify-center py-padding-xs flex-0 text-text-primary text-center w-column-width-md min-w-column-width-md"
                              }
                              style={{
                                color: "var(--settled)",
                                textAlign: "right",
                                justifyContent: "end",
                              }}
                            >
                              {statement.credit_debit == "Credit" ? (
                                <>
                                  INR{" "}
                                  <FormatAmount
                                    price={Number(statement?.amount)}
                                  />
                                </>
                              ) : (
                                "-"
                              )}
                            </div>
                          </>
                        )}
                        {additionalDetailColState?.some(
                          (x) => x.colName === "Closing balance",
                        ) && (
                          <>
                            <p
                              style={{ justifyContent: "end" }}
                              className={
                                "text-font-xs px-padding-md h-auto break-all flex items-center justify-center py-padding-xs flex-0 text-text-primary text-center w-column-width-md min-w-column-width-md"
                              }
                            >
                              INR{" "}
                              <FormatAmount
                                price={Number(statement?.closing_balance)}
                              />
                            </p>
                          </>
                        )}
                        {additionalDetailColState?.some(
                          (x) => x.colName === "Account number",
                        ) && (
                          <>
                            <p
                              onClick={(e) => {
                                e.stopPropagation();
                                if (
                                  props?.flow !== "rejectStatementdetails" &&
                                  props?.flow !== "ownerDetail"
                                ) {
                                  if (props?.popType != "ownerStatement") {
                                    setOwnerDetailID(
                                      statement.owner_account_id,
                                    );
                                    setTimeout(() => {
                                      setShowOwnerDetailPopup(true);
                                    }, 500);
                                  }
                                } else {
                                  if (props?.flow !== "ownerDetail") {
                                    actionRestricted();
                                  }
                                }
                              }}
                              className={`text-font-xs px-padding-md h-auto break-all flex ${props?.flow === "rejectStatementdetails" && "opacity-light-opacity cursor-not-allowed "} items-center justify-center py-padding-xs flex-0 text-text-primary text-center w-column-width-md min-w-column-width-md ${
                                props?.popType != "ownerStatement" &&
                                props?.flow !== "ownerDetail"
                                  ? "ownerredirect"
                                  : ""
                              } `}
                            >
                              {formatAccountNumber(
                                statement?.owner_bank_account_number,
                              ) || "-"}
                            </p>
                          </>
                        )}
                        {/* {additionalDetailColState?.some(
                          (x) => x.colName === "Source account number",
                        ) && (
                          <>
                            <p
                              style={{ justifyContent: "end" }}
                              className={
                                "text-font-xs px-padding-md h-auto break-all flex items-center justify-center py-padding-xs flex-0 text-text-primary text-center w-column-width-md min-w-column-width-md"
                              }
                            >
                              Source account number(Dummy)
                            </p>
                          </>
                        )} */}
                        {additionalDetailColState?.some(
                          (x) => x.colName === "Name",
                        ) && (
                          <>
                            <p
                              style={{ justifyContent: "end" }}
                              className={
                                "text-font-xs px-padding-md h-auto break-all flex items-center justify-center py-padding-xs flex-0 text-text-primary text-center w-column-width-md min-w-column-width-md"
                              }
                            >
                              {statement?.name}
                            </p>
                          </>
                        )}
                        {additionalDetailColState?.some(
                          (x) => x.colName === "IFSC code",
                        ) && (
                          <>
                            <p
                              className={
                                "text-font-xs px-padding-md h-auto break-all flex items-center justify-center py-padding-xs flex-0 text-text-primary text-center w-column-width-md min-w-column-width-md"
                              }
                            >
                              {statement?.ifsc_code || "-"}
                            </p>
                          </>
                        )}
                        {additionalDetailColState.some(
                          (x) => x.colName === "Statement source",
                        ) && (
                          <p
                            className={
                              "text-font-xs px-padding-md h-auto break-all flex items-center justify-center py-padding-xs flex-0 text-text-primary text-center w-column-width-md min-w-column-width-md"
                            }
                          >
                            {statement?.uploaded
                              ? "Uploaded manually"
                              : "Fetched from bank"}
                          </p>
                        )}
                        {/* {additionalDetailColState?.some(
                          (x) => x.colName === "Generated on",
                        ) && (
                          <>
                            <p
                              style={{ justifyContent: "end" }}
                              className={
                                "text-font-xs px-padding-md h-auto break-all flex items-center justify-center py-padding-xs flex-0 text-text-primary text-center w-column-width-md min-w-column-width-md"
                              }
                            >
                              01-08-2023(Dummy date)
                            </p>
                          </>
                        )} */}
                        {additionalDetailColState.some(
                          (x) => x.colName === "Description",
                        ) && (
                          <div
                            className={
                              " px-padding-md h-auto flex items-center justify-center py-padding-xs flex-1 text-text-primary text-center w-column-width-lg min-w-column-width-lg"
                            }
                          >
                            {statement?.description?.length ? (
                              <div className="flex gap-x-gap-sm justify-center">
                                <p className="text-font-xs text-text-secondary break-all">
                                  {linkIdentifier(statement?.description)}
                                </p>
                                <div className="border-r-border h-auto border-primary-act"></div>
                                <img
                                  title="Edit"
                                  src={ICONS?.EDIT}
                                  alt="edit"
                                  className={`h-icon-sm w-icon-sm flex-shrink-0  ${props?.flow === "rejectStatementdetails" && "opacity-light-opacity cursor-not-allowed "} ${matchButton && "opacity-light-opacity "} my-auto ${
                                    !services?.includes("ADescription") &&
                                    !services?.includes("Admin")
                                      ? "cursor-not-allowed opacity-light-opacity"
                                      : ` ${matchButton ? "cursor-default" : "cursor-pointer"}`
                                  } `}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    if (
                                      props?.flow === "rejectStatementdetails"
                                    ) {
                                      actionRestricted();
                                    } else {
                                      if (!matchButton) {
                                        if (
                                          !services?.includes("ADescription") &&
                                          !services?.includes("Admin")
                                        ) {
                                          navigate("/feature_not_assigned", {
                                            state: {
                                              unavailableService:
                                                "VAccountBalance,Admin",
                                            },
                                          });
                                        } else {
                                          setIsEditDescription(true);
                                          setDescription(
                                            statement?.description,
                                          );
                                          setCurrentDescription({
                                            acc_id: statement?.owner_account_id,

                                            description: statement?.description,
                                            account_statement_entry_id:
                                              statement?.account_statement_entry_id,
                                          });
                                          setShowDescriptionPopup(true);
                                        }
                                      }
                                    }
                                  }}
                                />
                              </div>
                            ) : (
                              <PrimaryWithIconButton
                                btnText="Add description"
                                outLineColor={"var(--text-primary)"}
                                btnType="button"
                                enabledBgColor="transparent"
                                enabledTextColor="var(--text-primary)"
                                hoverOption="white"
                                iconToBeAlign="left"
                                icon={ICONS?.ADD_BUTTON_WHITE}
                                imgColor="var(--text-primary)"
                                isDisabled={
                                  props?.flow === "rejectStatementdetails"
                                    ? true
                                    : matchButton
                                      ? true
                                      : !services?.includes("ADescription") &&
                                        !services?.includes("Admin")
                                }
                                handleFunction={(e) => {
                                  e.stopPropagation();
                                  if (
                                    props?.flow === "rejectStatementdetails"
                                  ) {
                                    actionRestricted();
                                  } else {
                                    if (!matchButton) {
                                      if (
                                        !services?.includes("ADescription") &&
                                        !services?.includes("Admin")
                                      ) {
                                        navigate("/feature_not_assigned", {
                                          state: {
                                            unavailableService:
                                              "ADescription,Admin",
                                          },
                                        });
                                      } else {
                                        setShowDescriptionPopup(true);
                                        setCurrentDescription({
                                          acc_id: statement?.owner_account_id,

                                          description: statement?.description,
                                          account_statement_entry_id:
                                            statement?.account_statement_entry_id,
                                        });
                                      }
                                    }
                                  }
                                }}
                              />
                            )}
                          </div>
                        )}
                        {props?.flow !== "rejectStatementdetails" &&
                          additionalDetailColState.some(
                            (x) => x.colName === "Remitter account",
                          ) && (
                            <div
                              className={`  h-auto flex items-center justify-center py-padding-xs flex-1 pr-padding-md Qsmd:pr-padding-base text-text-primary text-center w-column-width-lg min-w-column-width-lg `}
                            >
                              {statement?.remitter_accounts?.length ? (
                                <div className="flex gap-x-gap-xs w-full px-padding-md">
                                  <div className="w-full justify-between items-center flex">
                                    <div
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        if (hasViewPermission) {
                                          if (
                                            props?.flow ===
                                              "rejectStatementdetails" ||
                                            props?.flow === "ownerDetail"
                                          ) {
                                            actionRestricted();
                                          } else {
                                            setShowRemiAccounts(true);
                                            setTotalRemiAccount([
                                              statement?.remitter_accounts?.map(
                                                (itm) =>
                                                  itm.remitter_account_id,
                                              ),
                                            ]);
                                          }
                                        } else {
                                          navigate("/feature_not_assigned", {
                                            state: {
                                              unavailableService: "REVAccount",
                                            },
                                          });
                                        }
                                      }}
                                      className={`text-font-sm text-pending  underline ${props?.flow === "rejectStatementdetails" || props?.flow === "ownerDetail" ? "opacity-light-opacity cursor-not-allowed " : !hasViewPermission ? "opacity-light-opacity cursor-not-allowed" : "cursor-pointer"} `}
                                    >
                                      {`${statement?.remitter_accounts?.length}
                                    matched`}
                                    </div>

                                    <div
                                      className={` rounded-border-radius-md ${matchButton ? "hidden" : "block"} cursor-pointer  `}
                                    >
                                      <SecondaryAnimatedButton
                                        handleFunction={(e) => {
                                          e.stopPropagation();
                                          if (
                                            props?.flow ===
                                              "rejectStatementdetails" ||
                                            props?.flow === "ownerDetail"
                                          ) {
                                            actionRestricted();
                                          } else {
                                            if (!matchButton) {
                                              if (hasUnMatchPermission) {
                                                setShowRemiAccounts(true);
                                                setRemType("remitterUnmatch");
                                                setSelectStatementRow([
                                                  statement?.account_statement_entry_id,
                                                ]);
                                                setUnmatchRemiId(
                                                  statement?.remitter_accounts?.map(
                                                    (itm) =>
                                                      itm.remitter_account_id,
                                                  ),
                                                );
                                              } else {
                                                navigate(
                                                  "/feature_not_assigned",
                                                  {
                                                    state: {
                                                      unavailableService:
                                                        "RMapping",
                                                    },
                                                  },
                                                );
                                              }
                                            }
                                          }
                                        }}
                                        isDisabled={
                                          props?.flow ===
                                            "rejectStatementdetails" ||
                                          props?.flow === "ownerDetail" ||
                                          !hasUnMatchPermission
                                        }
                                        enabledBgColor={"var(--primary-nav)"}
                                        disabledBgColor=""
                                        isLoading={false}
                                        icon={ICONS.UNMATCH}
                                        imgColor={"var(--text-primary)"}
                                        hoverOption="white"
                                        buttonRef={buttonRef}
                                        title="Unmatch remitter accounts from transaction"
                                        text={"Unmatch"}
                                      />
                                    </div>
                                  </div>

                                  <div
                                    className={` ${matchButton ? " hidden" : "flex"}`}
                                  >
                                    <div
                                      className={` rounded-border-radius-md  cursor-pointer ${matchButton ? "hidden" : "block"} flex  `}
                                    >
                                      <SecondaryAnimatedButton
                                        handleFunction={(e) => {
                                          e.stopPropagation();

                                          if (
                                            props?.flow ===
                                              "rejectStatementdetails" ||
                                            props?.flow === "ownerDetail"
                                          ) {
                                            actionRestricted();
                                          } else {
                                            if (!matchButton) {
                                              if (hasMatchPermission) {
                                                setShowRemiAccounts(true);
                                                setRemType("remitterMatch");
                                                setSelectStatementRow([
                                                  statement?.account_statement_entry_id,
                                                ]);

                                                setMatchRemiId([
                                                  ...(statement?.remitter_accounts?.map(
                                                    (itm) =>
                                                      itm.remitter_account_id,
                                                  ) || []),
                                                  ...(Array.isArray(
                                                    remiAcoountId,
                                                  )
                                                    ? remiAcoountId
                                                    : remiAcoountId
                                                      ? [remiAcoountId]
                                                      : []),
                                                ]);

                                                setSelectedCardIds(
                                                  Array.isArray(remiAcoountId)
                                                    ? remiAcoountId
                                                    : [remiAcoountId],
                                                );
                                              } else {
                                                navigate(
                                                  "/feature_not_assigned",
                                                  {
                                                    state: {
                                                      unavailableService:
                                                        "AMapping",
                                                    },
                                                  },
                                                );
                                              }
                                            }
                                          }
                                        }}
                                        isDisabled={
                                          props?.flow ===
                                            "rejectStatementdetails" ||
                                          props?.flow === "ownerDetail" ||
                                          !hasMatchPermission
                                        }
                                        enabledBgColor={"var(--primary-nav)"}
                                        disabledBgColor=""
                                        isLoading={false}
                                        icon={ICONS.MATCH}
                                        hoverOption="white"
                                        buttonRef={buttonRef}
                                        title="Match remitter accounts to transaction"
                                        text={"Match"}
                                        imgColor={"var(--text-primary)"}
                                      />
                                    </div>
                                  </div>
                                </div>
                              ) : statement?.credit_debit !== "Debit" ? (
                                <>
                                  <PrimaryWithIconButton
                                    btnText="Match remitter account"
                                    outLineColor={"var(--text-primary)"}
                                    btnType="button"
                                    enabledBgColor="transparent"
                                    enabledTextColor="var(--text-primary)"
                                    hoverOption="white"
                                    iconToBeAlign="left"
                                    icon={ICONS.MATCHED_WITH_CIRCLE}
                                    imgColor="var(--text-primary)"
                                    isDisabled={
                                      !hasMatchPermission
                                        ? true
                                        : props?.flow ===
                                              "rejectStatementdetails" ||
                                            props?.flow === "ownerDetail"
                                          ? true
                                          : matchButton
                                            ? true
                                            : false
                                    }
                                    handleFunction={(e) => {
                                      e.stopPropagation();
                                      if (
                                        props?.flow ===
                                          "rejectStatementdetails" ||
                                        props?.flow === "ownerDetail"
                                      ) {
                                        actionRestricted();
                                      } else {
                                        if (hasMatchPermission) {
                                          if (!matchButton) {
                                            setSelectStatementRow([
                                              statement?.account_statement_entry_id,
                                            ]);
                                            setOpenMatchPopup(true);
                                          }
                                        } else {
                                          navigate("/feature_not_assigned", {
                                            state: {
                                              unavailableService: "AMapping",
                                            },
                                          });
                                        }
                                      }
                                    }}
                                  />
                                </>
                              ) : (
                                <></>
                              )}
                            </div>
                          )}
                      </div>
                    );
                  })}
                </div>
              </div>
            ) : (
              <div
                className={`flex-1 flex-col m-auto  ${
                  props?.popType === "ownerStatement"
                    ? "w-full-popup-width"
                    : "w-full-width"
                } ${ownerAllAccStatementData?.statement?.length || getAssociatedConsolidatedData?.statement?.length ? "pb-padding-xl" : "pb-padding-base"}  overflow-y-scroll justify-center items-center flex`}
              >
                {showInnerSearchBar && (
                  <>
                    <div className="absolute top-top-base left-left-base h-full w-full overflow-x-hidden pointer-events-none bg-PopUp-BackDrop opacity-dark-opacity z-z-index-header overflow-hidden"></div>
                  </>
                )}
                <img
                  src={
                    "https://q2pay.in/new_assets/graphics/no_data/no_data_found.svg"
                  }
                  alt="No accounts found"
                  className="w-graphic-rectangle-height-md h-graphic-rectangle-height-md"
                />
                <p className="text-text-primary text-font-sm pt-padding-sm items-center">
                  No data found.
                </p>

                {condition ? (
                  <>
                    {" "}
                    <div
                      style={{
                        paddingTop: "var(--padding-sm)",
                      }}
                    >
                      <PrimaryButton
                        isDisabled={
                          filterOpen || showAdditionalDetails || showCalendar
                        }
                        enabledBgColor="var(--primary-act)"
                        btnText="Clear parameters"
                        enabledTextColor="var(--text-primary)"
                        handleFunction={() => {
                          move();
                          if (props?.flow === "rejectStatementdetails") {
                            setaccountnumberstate([]);
                          } else {
                            setaccountnumberstate(accountDefaultNumber);
                          }
                          setDebitAmount("");
                          setCreditAmount("");
                          setSelectedtBankState("");
                          setSourceState("");
                          setStatementTypeState("");
                          setSelectStatementRow([]);
                          setAmountRangeFilter({
                            min: "",
                            max: "",
                          });
                          setUnMatchStatement("");
                          setMatchStatement("");
                          setMatchButton("");
                          setIsAmtFilterApplied(false);
                          if (props?.flow === "rejectStatementdetails") {
                            setStartDateState("");
                            setEndDateState("");
                          } else {
                            setStartDateState(defaultStartDate);
                            setEndDateState(defaultEndDate);
                          }

                          setIsDateConfirm(false);
                          setCurrentPage(1);
                        }}
                        buttonRef={selectAccountRef}
                        hoverOption="white"
                      />
                    </div>
                  </>
                ) : (
                  <>
                    {" "}
                    <div className=" mt-margin-sm">
                      <PrimaryButton
                        enabledBgColor="var(--primary-act)"
                        btnText="Change date range"
                        enabledTextColor="var(--text-primary)"
                        handleFunction={() => {
                          setopenDateFilter(true);
                        }}
                        buttonRef={selectAccountRef}
                        hoverOption="white"
                      />
                    </div>
                  </>
                )}
              </div>
            )}
          </div>
          <div
            className={`${
              getAssociatedConsolidatedData?.total_count ===
                GlobalConfiguration.lengthCheckZero ||
              props?.flow !== "rejectStatementdetails" ||
              getAssociatedConsolidatedLoading ||
              ownerAllAccStatementLoading
                ? "hidden"
                : "block h-pagination-height"
            }`}
          ></div>
        </div>
      </div>
    </>
  );
};

export default OwnerAccountConsolidatedBankStatement;
